/* eslint-disable */
// File generated by i18n-js

import { I18n } from "i18n-js";

const i18n = new I18n({
  "en": {
    "activated_tootltip_text": "If the configration is deactivated, you will no longer receive data.",
    "activerecord": {
      "attributes": {
        "configuration": {
          "import_sources": "Type de source",
          "name": "Nom",
          "time_zone": "Fuseau horaire",
          "transform_plan": "Plan de transformation"
        },
        "export_destinations": {
          "google_drive_filename": "Nom du fichier Google Drive",
          "google_drive_folder_id": "Dossier Google Drive",
          "microsoft_azure_account_name": "Nom du compte Microsoft Azure",
          "microsoft_azure_connection_string": "Chaîne de connexion Microsoft Azure",
          "microsoft_azure_container_name": "Nom du conteneur Microsoft Azure",
          "microsoft_azure_credentials": "Wrong account name or access key",
          "microsoft_azure_filename": "Nom du fichier Microsoft Azure",
          "microsoft_azure_folder_name": "Nom du dossier Microsoft Azure",
          "microsoft_azure_share_name": "Nom du partage de fichier Microsoft Azure",
          "microsoft_azure_storage_type": "Type de stockage Microsoft Azure"
        },
        "import_sources": {
          "interval": "Intervalle",
          "teeptrak_dashboard_id": "Dashboard TEEPTRAK",
          "teeptrak_factory_id": "Usine TEEPTRAK"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Validation failed: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Cannot delete record because dependent %{record} exist",
            "has_one": "Cannot delete record because a dependent %{record} exists"
          }
        }
      }
    },
    "api": "Api",
    "attributes": {
      "activated": "Activated",
      "created_at": "Created at",
      "deactivated": "Deactivated",
      "shift_started_at": "Shift started at",
      "started_at": "Started at",
      "teeptrak_machine_ids": "TEEPTRAK machines",
      "updated_at": "Updated at"
    },
    "back": "Back",
    "calendar_date_format": "MM/DD/YYYY HH:mm",
    "call_example": "Request example",
    "configuration": "Configuration",
    "configuration_sessions": {
      "failed": "Failed sessions",
      "many": "Sessions",
      "one": "Session"
    },
    "consolidated_losses_duration_for_a_machine": "Consolidated losses",
    "consolidatedloss": "Consolidated losses",
    "could_not_create": "Could not create!",
    "could_not_destroy": "Could not destroy!",
    "could_not_update": "Could not update!",
    "csv": "Csv",
    "custom_checkbox_tootltip_text": "If you check this box, unknown issues will be displayed. If not, they will be excluded. If there are unknown issues in the selected interval, a query will be made every hour for 12 hours to allow time to fill in the unknown issues. At the end of this time, if the selected interval still contains unknown issues, the response will be sent with them.",
    "custom_form": "Custom form",
    "custom_interval_invalid": "must have valid dates",
    "custom_interval_validation": "must be less than a year",
    "customform": "Custom form",
    "daily": "Daily",
    "dashboard": "Dashboard",
    "date": {
      "abbr_day_names": [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%B %d, %Y",
        "short": "%b %d"
      },
      "month_names": [
        null,
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "about %{count} hour",
          "other": "about %{count} hours"
        },
        "about_x_months": {
          "one": "about %{count} month",
          "other": "about %{count} months"
        },
        "about_x_years": {
          "one": "about %{count} year",
          "other": "about %{count} years"
        },
        "almost_x_years": {
          "one": "almost %{count} year",
          "other": "almost %{count} years"
        },
        "half_a_minute": "half a minute",
        "less_than_x_minutes": {
          "one": "less than a minute",
          "other": "less than %{count} minutes"
        },
        "less_than_x_seconds": {
          "one": "less than %{count} second",
          "other": "less than %{count} seconds"
        },
        "over_x_years": {
          "one": "over %{count} year",
          "other": "over %{count} years"
        },
        "x_days": {
          "one": "%{count} day",
          "other": "%{count} days"
        },
        "x_minutes": {
          "one": "%{count} minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "%{count} month",
          "other": "%{count} months"
        },
        "x_seconds": {
          "one": "%{count} second",
          "other": "%{count} seconds"
        },
        "x_years": {
          "one": "%{count} year",
          "other": "%{count} years"
        }
      },
      "prompts": {
        "day": "Day",
        "hour": "Hour",
        "minute": "Minute",
        "month": "Month",
        "second": "Seconds",
        "year": "Year"
      }
    },
    "datetime_format": "%m/%d/%Y %H:%M",
    "day": "Day",
    "defta_custom_one": "Defta custom",
    "defta_custom_two": "Defta custom 2",
    "deftacustomone": "Defta custom",
    "deftacustomtwo": "Defta custom 2",
    "error": "error",
    "errors": {
      "connection_refused": "Oops! Failed to connect to the Web Console middleware.\nPlease make sure a rails development server is running.\n",
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "must be accepted",
        "blank": "can't be blank",
        "confirmation": "doesn't match %{attribute}",
        "empty": "can't be empty",
        "equal_to": "must be equal to %{count}",
        "even": "must be even",
        "exclusion": "is reserved",
        "greater_than": "must be greater than %{count}",
        "greater_than_or_equal_to": "must be greater than or equal to %{count}",
        "in": "must be in %{count}",
        "in_between": "must be in between %{min} and %{max}",
        "inclusion": "is not included in the list",
        "invalid": "is invalid",
        "less_than": "must be less than %{count}",
        "less_than_or_equal_to": "must be less than or equal to %{count}",
        "model_invalid": "Validation failed: %{errors}",
        "not_a_number": "is not a number",
        "not_an_integer": "must be an integer",
        "odd": "must be odd",
        "other_than": "must be other than %{count}",
        "password_too_long": "is too long",
        "present": "must be blank",
        "required": "must exist",
        "spoofed_media_type": "has contents that are not what they are reported to be",
        "taken": "has already been taken",
        "too_long": {
          "one": "is too long (maximum is %{count} character)",
          "other": "is too long (maximum is %{count} characters)"
        },
        "too_short": {
          "one": "is too short (minimum is %{count} character)",
          "other": "is too short (minimum is %{count} characters)"
        },
        "wrong_length": {
          "one": "is the wrong length (should be %{count} character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      },
      "template": {
        "body": "There were problems with the following fields:",
        "header": {
          "one": "%{count} error prohibited this %{model} from being saved",
          "other": "%{count} errors prohibited this %{model} from being saved"
        }
      },
      "unacceptable_request": "A supported version is expected in the Accept header.\n",
      "unavailable_session": "Session %{id} is no longer available in memory.\n\nIf you happen to run on a multi-process server (like Unicorn or Puma) the process\nthis request hit doesn't store %{id} in memory. Consider turning the number of\nprocesses/workers to one (1) or using a different server in development.\n"
    },
    "event_feed": "Events (feed)",
    "eventfeed": "Events (feed)",
    "events": "Events",
    "every": "Every",
    "export_destination": "Destination",
    "false": "No",
    "finished": "finished",
    "flexible_interval_dashboard_performances": "Dashboards KPIs",
    "flexibleintervaldashboard": "Dashboards KPIs",
    "flow_configurations": {
      "container": "Container",
      "created": "Flow successfully created!",
      "delete_flow": "Are you sure?",
      "destroyed": "Flow successfully destroyed!",
      "edit": "Edit flow configuration",
      "export_destinations": {
        "google_drive": {
          "instructions_html": "For Gate to be able to export data to Google Drive, your must create a <strong>Shared Drive</strong> in your Google Drive and share it with <strong>%{email}</strong> with the <i>Content manager</i> role. The Folder ID is the part at the end of the URL when you are in the folder (https://drive.google.com/drive/folders/FOLDER_ID).\n"
        }
      },
      "file_share": "File share",
      "form": {
        "actions": "Actions",
        "api": "API",
        "api_information": "API Information",
        "api_warning": "API credentials will be prompted to you once the configuration is saved.",
        "authorization_bearer": "Authorization Bearer",
        "custom_interval": "Custom interval",
        "custom_interval_tooltip": "Once the form is validated, you will not be able to change the custom interval.",
        "day": "Day",
        "day_number": "Day Number",
        "days": "Days",
        "destination": "Destination",
        "destination_tooltip": "Select data container.",
        "display_uninformed_issues": "Display unknown issues",
        "endpoint": "Endpoint",
        "error": {
          "export_destinations": {
            "google_drive_filename": "Google Drive filename can't be blank",
            "google_drive_folder_id": "Google Drive folder can't be blank",
            "microsoft_azure_account_name": "Microsoft Azure account name can't be blank",
            "microsoft_azure_connection_string": "Microsoft Azure connection string can't be blank",
            "microsoft_azure_container_name": "Microsoft Azure container name can't be blank",
            "microsoft_azure_filename": "Microsoft Azure filename can't be blank",
            "microsoft_azure_folder_name": "Microsoft Azure folder name can't be blank",
            "microsoft_azure_share_name": "Microsoft Azure file share name can't be blank",
            "microsoft_azure_storage_type": "Microsoft Azure storage type can't be blank"
          },
          "import_sources": {
            "interval": "Interval can't be blank",
            "teeptrak_dashboard": "TEEPTRAK dashboard can't be blank",
            "teeptrak_factory": "TEEPTRAK factory can't be blank",
            "teeptrak_machine": "TEEPTRAK machine can't be blank",
            "teeptrak_machines": "TEEPTRAK machines can't be blank"
          }
        },
        "frequency_readonly_html": "Les paramètres de fréquence ne peuvent pas être mis à jour une fois la configuration enregistrée.<br />Vous pouvez créer une nouvelle configuration de flux pour modifier la fréquence.",
        "google_drive_filename": "Google Drive filename",
        "google_drive_folder_id": "Google Drive folder ID",
        "id": "Id",
        "interval": "Interval",
        "interval_tooltip": "Select the periodicity.",
        "microsoft_azure_account_name": "Microsoft Azure account name",
        "microsoft_azure_connection_string": "Microsoft Azure connection string",
        "microsoft_azure_container_name": "Microsoft Azure container name",
        "microsoft_azure_filename": "Microsoft Azure filename",
        "microsoft_azure_folder_name": "Microsoft Azure folder name",
        "microsoft_azure_share_name": "Microsoft Azure file share name",
        "microsoft_azure_storage_type": "Microsoft Azure storage type",
        "name": "Name",
        "optional_params": "Optional params",
        "qualtrak_machine": "Machine Qualtrak",
        "schedule": "Frequency",
        "schedule_tooltip": "Extracted data will be performed at this frequency.",
        "source": "Source",
        "teeptrak_custom_form": "TEEPTRAK custom form",
        "teeptrak_dashboard": "TEEPTRAK dashboard",
        "teeptrak_factory": "TEEPTRAK factory",
        "teeptrak_import_export_profile": "TEEPTRAK export profile",
        "teeptrak_machine": "TEEPTRAK machine",
        "teeptrak_machines": "TEEPTRAK machines",
        "teeptrak_product_names": "TEEPTRAK product names",
        "time": "Time",
        "transform_plan": "Plan de transformation",
        "transform_plan_tooltip": "Select extracted data format type.",
        "type": "Type",
        "type_tooltip": "Type of data to extract.",
        "update_behaviour": "File update behaviour",
        "user": "User"
      },
      "increment_content": "Increment content",
      "index": {
        "actions": "Actions",
        "customer": "Customer",
        "id": "Id",
        "interval": "Interval",
        "name": "Name",
        "schedule": "Schedule",
        "time": "Time",
        "type": "Type",
        "user": "User"
      },
      "many": "Flow configurations",
      "new": "New flow configuration",
      "new_file": "New file",
      "not_set": "Non renseigné",
      "one": "Flow configuration",
      "replace_with_new_content": "Replace with new content",
      "show": {
        "account_name": "Account name",
        "actions": "Actions",
        "api": "API",
        "authorization_bearer": "Authorization Bearer",
        "behaviour": "Behaviour",
        "container_name": "Container name",
        "csv": "Csv",
        "dashboard_id": "TEEPTRAK Dashboard",
        "day": "Day",
        "day_number": "Day",
        "days": "Days",
        "destination": "Destination",
        "endpoint": "Endpoint",
        "events_params": {
          "csv_streaming_description_html": "The CSV format (<code>.csv</code>) streams all pages in a single response — just call the endpoint once to receive the full dataset.",
          "csv_streaming_title": "CSV format",
          "cursor_description": "pagination token from the previous response — pass it to get the next page",
          "limit_description": "maximum number of events to return per request",
          "pagination_step_1_html": "Set <code>since</code> to the date after which you want to retrieve events (required, ISO 8601 format, e.g. <code>2025-01-15T00:00:00Z</code>)",
          "pagination_step_2_html": "Call the endpoint — you will receive up to 2000 events per page (customizable via <code>limit</code>, max 2000)",
          "pagination_step_3_html": "Use the <code>links.next</code> URL from the response to get the next page",
          "pagination_step_4_html": "Keep fetching the next page until the number of returned items is less than <code>limit</code> — you have reached the last page. Save <code>meta.next_cursor</code> to fetch new data arriving later.",
          "pagination_title": "How to retrieve events (JSON)",
          "parameters_heading": "Parameters",
          "since_description": "fetch events after this date"
        },
        "factory_id": "TEEPTRAK factory",
        "feed_params": {
          "bounded_cursor_html": "The cursor then stays bound to that period for good. Once there is no next page, do not reuse that cursor to wait for new data. Start the next period by reusing the former <code>until</code> as the new <code>since</code>.",
          "bounded_intro_html": "You may add <code>until</code> to limit <code>changes</code> to a period:",
          "bounded_title_html": "Limiting <code>changes</code> to a period",
          "col_code": "Code",
          "col_description": "Description",
          "col_feed": "Feed",
          "col_meaning": "Meaning",
          "col_parameter": "Parameter",
          "col_status": "Status",
          "col_use": "Use",
          "csv_bounded_html": "Use <code>timeline</code>, or <code>changes</code> with <code>until</code>, so that the download covers a finite period.",
          "csv_description_html": "Replace <code>.json</code> with <code>.csv</code> to have Gate walk through the pages and progressively stream their rows into a single file.",
          "csv_duration": "The download can take several minutes. If it is interrupted after it has started, the file may be incomplete without containing an error message. For automated processing that must check every page, prefer JSON.",
          "csv_title": "Downloading a CSV file",
          "cursor_fixed": "The other settings, including the period, the machines, the time zone, the language and the custom fields, are stored in the cursor and stay the same for the whole read.",
          "cursor_limit_html": "With a cursor, only <code>limit</code> may be added, to shrink or grow the pages, for example after a timeout. No other parameter is accepted.",
          "cursor_opaque": "The cursor is opaque: do not read it and do not modify it.",
          "cursor_prefer_link_html": "Preferably use the full URL given in <code>links.next</code>. You may also send the cursor on its own:",
          "cursor_title": "Resuming with a cursor",
          "end_changes_bounded": "The bounded period is finished. Start a new period with since.",
          "end_changes_bounded_label_html": "<code>changes</code> with <code>until</code>",
          "end_changes_open": "No other row is available for now. Keep the cursor for the next call.",
          "end_changes_open_label_html": "<code>changes</code> without <code>until</code>",
          "end_intro": "The end of a read does not mean quite the same thing on each feed:",
          "end_timeline": "The period is finished. There is no cursor left to keep.",
          "end_timeline_label_html": "<code>timeline</code>",
          "error_bad_credentials_html": "The authorization token is missing or invalid.",
          "error_gateway_html": "TEEPTRAK did not answer. Call exactly the same URL again.",
          "error_invalid_cursor_html": "The cursor cannot be used on this feed. Start again with the parameters of the first call.",
          "error_invalid_parameter_html": "A parameter is missing, incorrect, or not allowed on this call.",
          "error_rate_limit_html": "The call limit is reached. Wait before calling exactly the same URL again.",
          "error_unauthorized_machines_html": "One or more machines are not accessible with this flow. Their identifiers are given in <code>details.machine_ids</code>.",
          "errors_intro_html": "Always check the HTTP status before reading the response. Parameter and machine access errors return an <code>error</code> object holding <code>code</code>, <code>message</code> and <code>details</code>.",
          "errors_title": "When a call fails",
          "intro": "The API offers two ways of walking through the data. Which one to use depends on what you want to do.",
          "intro_title_html": "Reading data with <code>changes</code> and <code>timeline</code>",
          "limit_description_html": "Number of rows per page, from 1 to 2,000. Default: 2,000.",
          "lost_column_html": "Do not use <code>started_at</code> or <code>event_at</code> to resume <code>changes</code>. Because <code>since</code> is included, some rows will be received again: update them by their <code>id</code>.",
          "lost_precision_html": "If your system does not keep the full precision of <code>updated_at</code>, choose a slightly earlier date so as not to risk skipping a row.",
          "lost_restart_html": "Start again with a new <code>since</code> equal to the last <code>updated_at</code> you processed successfully.",
          "lost_title": "If the cursor is lost",
          "machine_ids_description_html": "Restricts the read to certain machines of the flow. Up to 50 identifiers.",
          "machine_ids_example": "Example with several machines:",
          "order": "Both feeds return results from oldest to most recent.",
          "order_changes_html": "<code>changes</code> uses the last modification date, <code>updated_at</code>.",
          "order_timeline_html": "<code>timeline</code> uses <code>started_at</code> for production data and losses, and <code>event_at</code> for events.",
          "parameters_heading": "Parameters of the first call",
          "parameters_note_html": "Dates must carry their offset from UTC, for example <code>Z</code> or <code>+02:00</code>. In a URL, write the <code>+</code> character as <code>%2B</code>.",
          "period_bounds_html": "<code>since</code> is included and <code>until</code> is excluded. The example above therefore covers the whole of September without including October 1st.",
          "period_chain_first": "first period",
          "period_chain_html": "To chain several periods without overlap, reuse the value of <code>until</code> as the new <code>since</code>:",
          "period_chain_next": "next period",
          "period_done_html": "The period has then been fully read and <code>meta.cursor</code> is also <code>null</code>.",
          "period_first_call_html": "The first call must contain <code>since</code> and <code>until</code>:",
          "period_intro_html": "Use <code>timeline</code> for an export or to read a given period, for example in Power BI.",
          "period_late_changes_html": "<code>timeline</code> follows the business date. A row added or modified after its period was read may therefore not appear in a later read. Use <code>changes</code> to retrieve later creations and modifications.",
          "period_restart_html": "If the read is interrupted, resume with the last URL received in <code>links.next</code>. If you did not keep it, start the same period again.",
          "period_step_1_html": "call the feed with <code>since</code> and <code>until</code>;",
          "period_step_2_html": "if <code>links.next</code> holds a URL, call that URL without modifying it, with the same <code>Authorization</code> header;",
          "period_step_3_html": "continue until <code>links.next</code> is <code>null</code>.",
          "period_steps_intro": "To walk through the period:",
          "period_title_html": "Reading a period with <code>timeline</code>",
          "rate_limit": "Allow at least two seconds between two calls, within a limit of 500 calls per hour and per token.",
          "response_count_html": "<code>meta.count</code> gives the number of rows in this response;",
          "response_cursor_html": "<code>meta.cursor</code> gives the position reached after this response.",
          "response_data_html": "<code>data</code> holds the rows requested;",
          "response_has_more_html": "<code>meta.has_more</code> says whether another page is available immediately;",
          "response_intro": "A response holds the data, the state of the read and, when there is one, the URL of the next page.",
          "response_next_html": "<code>links.next</code> holds the URL of the next page, or <code>null</code> when there is none;",
          "response_title": "Understanding a JSON response",
          "since_description_html": "Start date and time, included. Required. On <code>changes</code>, it applies to <code>updated_at</code>. On <code>timeline</code>, it applies to the business date.",
          "sync_checkpoint": "Store the cursor only after processing every row in the response. That way, an interruption will not make you skip data.",
          "sync_cursor_kept_html": "Even when no new row is available, the <code>changes</code> cursor is still there. It lets you resume later from the same place.",
          "sync_first_call": "On the first call, give only the start date:",
          "sync_intro_html": "Use <code>changes</code> to retrieve rows by their last modification date.",
          "sync_step_1_html": "process every row in <code>data</code>;",
          "sync_step_2_html": "follow <code>links.next</code> as long as a next page is available;",
          "sync_step_3_html": "when <code>links.next</code> is <code>null</code>, keep the value of <code>meta.cursor</code>;",
          "sync_step_4": "on the next call, send that cursor without modifying it.",
          "sync_steps_intro": "To carry on reading:",
          "sync_title_html": "Regularly reading creations and modifications with <code>changes</code>",
          "sync_upsert_html": "A row already received may come back with the same <code>id</code> after a modification. The client must therefore update its data by that <code>id</code>. Deleted rows are not returned by this feed.",
          "timezone_description_html": "Time zone used to write the dates, for example <code>Europe/Paris</code>. It does not change the data selected.",
          "until_description_html": "End date and time, excluded. Required on <code>timeline</code> and optional on <code>changes</code>.",
          "use_changes": "Regularly read the rows created or modified.",
          "use_timeline": "Read a finite period by the business date of the data.",
          "value_present": "present",
          "with_custom_fields_description_html": "Adds the custom fields to the response. Default: <code>false</code>."
        },
        "feeds_testing_badge": "Under test",
        "feeds_testing_notice": "These feeds are under test: the format of the answers can still change. Contact your TEEPTRAK representative before putting an integration into production.",
        "filename": "Filename",
        "folder_id": "Folder",
        "folder_name": "Folder name",
        "id": "Id",
        "interval": "Interval",
        "json": "JSON",
        "machine_id": "TEEPTRAK machine",
        "machine_ids": "TEEPTRAK machines",
        "method": "Method",
        "name": "Name",
        "no_custom_form_founded": "No custom form founded",
        "no_factory_found": "No Factory founded",
        "no_import_export_profile_founded": "No export profile founded",
        "no_machine_found": "No machine founded",
        "no_product_founded": "No product founded",
        "none": "No Transformation",
        "optional_params": {
          "as_many_machine_filters_as_you_want": "add as many params as machines you want to filter",
          "boolean": "boolean",
          "column": "Column",
          "created_at_gteq_description_content": "greater than or equal to",
          "created_at_lteq_description_content": "lesser than or equal to",
          "date_format": "YYYY-MM-DD HH:mm:ss",
          "datetime": "datetime",
          "default": "Default",
          "description": "Description",
          "empty": "empty",
          "ended_at_gteq_description_content": "greater than or equal to",
          "ended_at_lteq_description_content": "lesser than or equal to",
          "filter_by_machine_ids_description_content": "filter by machine id",
          "format": "Format",
          "heading": "Optional params",
          "info": "Info",
          "integer": "integer",
          "maximum": "Maximum",
          "minimum": "Minimum",
          "order_by_shift_started_at": "order the results by shift start date",
          "order_description_content": "order the results by updated date",
          "page_description_content": "which page number to return from the API",
          "page_size_description_content": "how many results to return per page from the API",
          "required": "Required",
          "started_at_gteq_description_content": "greater than or equal to",
          "started_at_lteq_description_content": "lesser than or equal to",
          "string": "string",
          "updated_at_gteq_description_content": "greater than or equal to",
          "updated_at_lteq_description_content": "lesser than or equal to",
          "with_custom_fields_description_content": "allow display of custom fields"
        },
        "performance_logs_params": {
          "csv_streaming_description_html": "The CSV format (<code>.csv</code>) streams all pages in a single response — just call the endpoint once to receive the full dataset.",
          "csv_streaming_title": "CSV format",
          "cursor_description": "pagination token from the previous response — pass it to get the next page",
          "filters_heading": "Optional filters",
          "limit_description": "maximum number of performance logs to return per request",
          "machine_ids_description": "filter results to specific machine IDs (subset of authorized machines)",
          "pagination_step_1_html": "Set <code>since</code> to the date after which you want to retrieve performance logs (required, ISO 8601 format, e.g. <code>2025-01-15T00:00:00Z</code>)",
          "pagination_step_2_html": "Call the endpoint — you will receive up to 2000 records per page (customizable via <code>limit</code>, max 2000)",
          "pagination_step_3_html": "Use the <code>links.next</code> URL from the response to get the next page",
          "pagination_step_4_html": "Keep fetching the next page until the number of returned items is less than <code>limit</code> — you have reached the last page. Save <code>meta.next_cursor</code> to fetch new data arriving later.",
          "pagination_title": "How to retrieve performance logs (JSON)",
          "parameters_heading": "Parameters",
          "range_filter_description": "must be used together — finds records whose time range overlaps with the query range",
          "since_description": "fetch performance logs updated after this date",
          "with_custom_fields_description": "include custom field values in the response"
        },
        "schedule": "Schedule",
        "share_name": "Share name",
        "simplified_losses_v2_params": {
          "csv_streaming_description_html": "The CSV format (<code>.csv</code>) streams all pages in a single response — just call the endpoint once to receive the full dataset.",
          "csv_streaming_title": "CSV format",
          "cursor_description": "pagination token from the previous response — pass it to get the next page",
          "filters_heading": "Optional filters",
          "limit_description": "maximum number of simplified losses to return per request",
          "machine_ids_description": "filter results to specific machine IDs (subset of authorized machines)",
          "pagination_step_1_html": "Set <code>since</code> to the date after which you want to retrieve simplified losses (required, ISO 8601 format, e.g. <code>2025-01-15T00:00:00Z</code>)",
          "pagination_step_2_html": "Call the endpoint — you will receive up to 2000 records per page (customizable via <code>limit</code>, max 2000)",
          "pagination_step_3_html": "Use the <code>links.next</code> URL from the response to get the next page",
          "pagination_step_4_html": "Keep fetching the next page until the number of returned items is less than <code>limit</code> — you have reached the last page. Save <code>meta.next_cursor</code> to fetch new data arriving later.",
          "pagination_title": "How to retrieve simplified losses (JSON)",
          "parameters_heading": "Parameters",
          "range_filter_description": "must be used together — finds records whose time range overlaps with the query range",
          "since_description": "fetch simplified losses updated after this date",
          "with_custom_fields_description": "include custom field values in the response"
        },
        "source": "Source",
        "storage_type": "Storage type",
        "time": "Time",
        "time_zone": "Time Zone",
        "transform_plan": "Transform plan",
        "type": "Type",
        "user": "User"
      },
      "updated": "Flow successfully updated!"
    },
    "flow_histories": {
      "created": "Flow history successfully created!",
      "destroyed": "Flow history successfully destroyed!",
      "index": {
        "actions": "Actions",
        "created_at": "Executed at",
        "daterangepicker": {
          "apply_label": "Apply",
          "april": "April",
          "august": "August",
          "cancel_label": "Cancel",
          "december": "December",
          "february": "February",
          "fr": "Fr",
          "january": "January",
          "july": "July",
          "june": "June",
          "march": "March",
          "may": "May",
          "mo": "Mo",
          "november": "November",
          "october": "October",
          "sa": "Sa",
          "september": "September",
          "su": "Su",
          "th": "Th",
          "tu": "Tu",
          "we": "We"
        },
        "filter": "Filter",
        "flow_configuration": "Flow configuration",
        "id": "Id",
        "interval": "Interval",
        "no_results_founded": "No results founded in the selected range"
      },
      "many": "Flow history",
      "one": "Flow history",
      "show": {
        "Status": "Status",
        "actions": "Actions",
        "flow_configuration": "Flow configuration",
        "id": "Id",
        "operator": "Operator"
      },
      "updated": "Flow history successfully updated!"
    },
    "friday": "Friday",
    "gate_monitoring": "Gate monitoring",
    "googledrive": "Google Drive",
    "helpers": {
      "page_entries_info": {
        "entry": {
          "one": "entry",
          "other": "entries",
          "zero": "entries"
        },
        "more_pages": {
          "display_entries": "Displaying %{entry_name} <b>%{first}&nbsp;-&nbsp;%{last}</b> of <b>%{total}</b> in total"
        },
        "one_page": {
          "display_entries": {
            "one": "Displaying <b>1</b> %{entry_name}",
            "other": "Displaying <b>all %{count}</b> %{entry_name}",
            "zero": "No %{entry_name} found"
          }
        }
      },
      "select": {
        "prompt": "Please select"
      },
      "submit": {
        "create": "Create %{model}",
        "submit": "Save %{model}",
        "update": "Update %{model}"
      }
    },
    "hi": "Hi",
    "home": {
      "show": {
        "actions": "Actions",
        "errors": "Errors",
        "exports": "Exports",
        "flow_configuration": "Flow configuration",
        "id": "Id",
        "imports": "Imports",
        "in_total": "in total",
        "last_exports": "Last exports",
        "last_imports": "Last imports",
        "last_week_errors": "Erreurs sur 7 jours",
        "operator": "Operator",
        "status": "Status",
        "transformations": "Transformations"
      }
    },
    "hour": "Hour",
    "hour_label_tootltip_text": "If you choose the time 00:00 the extraction will be done on the chosen day from the morning. For example, with the reference day &quot;Monday&quot; at 00:00, the extraction will be done from 00:00 on Monday morning.",
    "hour_label_tootltip_text_FID": "If you choose the time 06:00 the extraction will be done on the previous day from 06:00 to the next day 06:00",
    "hourly": "Hourly",
    "hours": "Hours",
    "hutchinson_custom_one": "Hutchinson custom",
    "hutchinsoncustomone": "Hutchinson custom",
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      },
      "transliterate": {
        "rule": {
          "À": "A",
          "Â": "A",
          "Æ": "Ae",
          "Ç": "C",
          "È": "E",
          "É": "E",
          "Ê": "E",
          "Ë": "E",
          "Î": "I",
          "Ï": "I",
          "Ô": "O",
          "Ù": "U",
          "Û": "U",
          "Ü": "U",
          "à": "a",
          "â": "a",
          "æ": "ae",
          "ç": "c",
          "è": "e",
          "é": "e",
          "ê": "e",
          "ë": "e",
          "î": "i",
          "ï": "i",
          "ô": "o",
          "ù": "u",
          "û": "u",
          "ü": "u",
          "ÿ": "y",
          "Œ": "Oe",
          "œ": "oe",
          "Ÿ": "Y"
        }
      }
    },
    "import_export_profile": "Export profile",
    "in_progress": "in progress",
    "interval": {
      "a_week_ago": "A week ago",
      "custom_interval": "Custom interval",
      "last_12_hours": "Last 12 hours",
      "last_21_days": "Last 21 days",
      "last_24_hours": "Last 24 hours",
      "last_2_hours": "Last 2 hours",
      "last_30_days": "Last 30 days",
      "last_6_hours": "Last 6 hours",
      "last_7_days": "Last 7 days",
      "last_8_hours": "Last 8 hours",
      "last_day": "Last day",
      "last_hour": "Last hour",
      "last_month": "Last month"
    },
    "json": "JSON",
    "logout": "Logout",
    "machineproductcount": "Product counts",
    "merck_custom_one": "Merck custom",
    "merckcustomone": "Merck custom",
    "microsoftazure": "Microsoft Azure",
    "monday": "Monday",
    "monitoring": "Monitoring",
    "month": "Month",
    "monthly": "Monthly",
    "new_account_could_not_be_saved": "New account could not be saved",
    "next": "Next",
    "no_transformation": "No Transformation",
    "not_finished": "Not Finished",
    "nth_each_month": "th of each month",
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "negative_format": "-%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Billion",
            "million": "Million",
            "quadrillion": "Quadrillion",
            "thousand": "Thousand",
            "trillion": "Trillion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB",
            "zb": "ZB"
          }
        }
      },
      "nth": {},
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "operation_not_found": "Requested operation was not found!",
    "operations": {
      "one": "Operation",
      "show": {
        "content": "Content",
        "created_at": "Created at",
        "errors": "Errors",
        "finished_at": "Finished at",
        "flow": "Flow configuration",
        "id": "ID",
        "informations": "Informations",
        "initiator": "Initiator",
        "logs": "Logs",
        "name": "Name",
        "no_errors": "No errors",
        "partial_coverage": {
          "summary": "The export delivered this window, but the platform could not compute it for the machines below. Their data is missing from the file, and their periods are not empty.",
          "title": "Some machines are missing from this export"
        },
        "processed_files": "Processed files",
        "started_at": "Started at",
        "status": "Status",
        "undeliverable_export": {
          "covered_from": "Covered from",
          "machine": "Machine",
          "platform_error": "Reported by the platform",
          "range": "from %{started_at} to %{ended_at}",
          "reason": "Reason",
          "reasons": {
            "no_loss_configuration": "This machine has no loss configuration assigned. Assign one so the platform can compute this window.",
            "no_pace_cause_configuration": "This machine has no pace cause configuration assigned. Assign one so the platform can compute this window.",
            "no_shift_configuration": "This machine has no shift configuration assigned. Assign one so the platform can compute this window.",
            "no_shift_schedule_in_range": "The shift configuration of this machine places no shift inside this window. Extend it over this window, or set the flow to a window it covers.",
            "range_starts_before_shift_configuration": "The window starts before the start date of the shift configuration of this machine. Move that start date earlier, or set the flow to a window starting on or after it.",
            "shift_configuration_has_unassigned_duration": "The shift configuration of this machine leaves periods with no shift, so its shift durations do not fill its cycle. Fill in the missing periods.",
            "shift_configuration_not_anchored": "The shift configuration of this machine has no start date. Set a start date on or before this window."
          },
          "summary": "The platform could not compute this window, so the export delivered nothing for it. This period is not empty.",
          "title": "No data delivered for this window",
          "uncovered_machines": "Machines not covered",
          "utc_timestamp": "%{timestamp} UTC",
          "window": "Window"
        }
      }
    },
    "pace_defta_custom_one": "PACETRAK Defta custom",
    "pacedeftacustomone": "PACETRAK Defta custom",
    "pending": "pending",
    "per_shift": "Per shift",
    "perf_cycletime_product": "Perf Cycletime products",
    "perf_startstop_product": "Perf Startstop products",
    "perfcycletimeproduct": "Perf Cycletime products",
    "performance_log": "Performance Logs (v2)",
    "performance_log_feed": "Performance Logs (feed)",
    "performancelogfeed": "Performance Logs (feed)",
    "perfstartstopproduct": "Perf Startstop products",
    "please_choose_a_custom_interval": "Choose an interval",
    "please_choose_an_option": "Please choose an option",
    "please_choose_the_desired_export_destination": "Please choose the desired export destination",
    "please_choose_the_desired_source": "Please choose the desired source",
    "please_choose_the_desired_transform_plan": "Please choose the desired transform plan",
    "please_fill_in_the_form_below": "Please fill in the form below",
    "please_review_the_errors_below": "Please review the errors below",
    "powered_by_teeptrak": "powered by TEEPTRAK",
    "privacy_policy": "Data privacy (GDPR)",
    "product_counts_for_a_machine": "Product counts",
    "product_name_label_tootltip_text": "Product selection is optional",
    "production_order_line": "Production orders",
    "productionorderline": "Production orders",
    "qual_hutchinson_custom_one": "Qualtrak Hutchinson custom",
    "qualhutchinsoncustomone": "Qualtrak Hutchinson custom",
    "quartly": "Every 15 mn",
    "raw_data": "Raw data (deprecated)",
    "rawdata": "Raw Data (deprecated)",
    "required": "required",
    "saturday": "Saturday",
    "save_form": "Save Form",
    "savencia_custom_one": "Savencia custom",
    "savenciacustomone": "Savencia custom",
    "server_alibaba_shanghai": "Server located in Shanghai",
    "server_alibaba_shenzhen": "Server located in Shenzhen",
    "server_ovh": "Servers located in Europe",
    "shiftly": "Shiftly",
    "simple_form": {
      "error_notification": {
        "default_message": "Please review the problems below:"
      },
      "labels": {
        "configuration": {
          "cron": "Planning",
          "day": "Jour",
          "day_number": "Jour",
          "days": "Jours",
          "name": "Nom",
          "time": "Heure"
        },
        "import_source": {
          "interval": "Intevalle",
          "type": "Type"
        }
      },
      "no": "No",
      "non": "Non",
      "oui": "Oui",
      "required": {
        "mark": "*",
        "text": "required"
      },
      "yes": "Yes"
    },
    "simplified_loss_feed": "Simplified Losses (feed)",
    "simplified_loss_v2": "Simplified Losses (v2)",
    "simplified_losses": {
      "maximum_requests": "You have made too much requests in one hour. You must wait %{maximum_requests} hours to be able to make more requests.",
      "time_before_next_request": "Too much simultaneous requests. Please wait %{time_before_next_request} seconds."
    },
    "simplified_losses_duration_for_a_machine": "Simplified losses (deprecated)",
    "simplifiedloss": "Simplified losses (deprecated)",
    "simplifiedlossfeed": "Simplified Losses (feed)",
    "simplifiedlossv2": "Simplified Losses (v2)",
    "solina_custom_one": "SOLINA custom",
    "solina_custom_two": "SOLINA custom (2)",
    "solinacustomone": "SOLINA custom",
    "solinacustomtwo": "SOLINA custom (2)",
    "source": "Source",
    "sunday": "Sunday",
    "support": {
      "array": {
        "last_word_connector": ", and ",
        "two_words_connector": " and ",
        "words_connector": ", "
      }
    },
    "thursday": "Thursday",
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%B %d, %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    },
    "total_of": "Total of",
    "transform_plan": "Transform plan",
    "true": "Yes",
    "tuesday": "Tuesday",
    "type": "Type",
    "views": {
      "pagination": {
        "first": "&laquo; First",
        "last": "Last &raquo;",
        "next": "Next &rsaquo;",
        "previous": "&lsaquo; Prev",
        "truncate": "&hellip;"
      }
    },
    "wednesday": "Wednesday",
    "week": "Week",
    "weekly": "Weekly",
    "welcome_to_teeptrak_gate": "Welcome to TEEPTRAK Gate"
  },
  "fr": {
    "activated_tootltip_text": "Si la configuration est désactivée, vous ne receverez plus de données.",
    "activerecord": {
      "attributes": {
        "configuration": {
          "import_sources": "Type de source",
          "name": "Nom",
          "time_zone": "Fuseau horaire",
          "transform_plan": "Plan de transformation"
        },
        "export_destinations": {
          "google_drive_filename": "Nom du fichier Google Drive",
          "google_drive_folder_id": "Dossier Google Drive",
          "microsoft_azure_account_name": "Nom du compte Microsoft Azure",
          "microsoft_azure_connection_string": "Chaîne de connexion Microsoft Azure",
          "microsoft_azure_container_name": "Nom du conteneur Microsoft Azure",
          "microsoft_azure_credentials": "Nom de compte ou clé d'accès erroné",
          "microsoft_azure_filename": "Nom du fichier Microsoft Azure",
          "microsoft_azure_folder_name": "Nom du dossier Microsoft Azure",
          "microsoft_azure_share_name": "Nom du partage de fichier Microsoft Azure",
          "microsoft_azure_storage_type": "Type de stockage Microsoft Azure"
        },
        "import_sources": {
          "interval": "Intervalle",
          "teeptrak_dashboard_id": "Dashboard TEEPTRAK",
          "teeptrak_factory_id": "Usine TEEPTRAK"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "La validation a échoué : %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Vous ne pouvez pas supprimer l'enregistrement parce que les %{record} dépendants existent",
            "has_one": "Vous ne pouvez pas supprimer l'enregistrement car un(e) %{record} dépendant(e) existe"
          }
        }
      }
    },
    "api": "Api",
    "attributes": {
      "activated": "Activé",
      "created_at": "Créé(e) le",
      "deactivated": "Désactivée",
      "shift_started_at": "L'équipe a commencé à",
      "started_at": "Commencé à",
      "teeptrak_machine_ids": "Machines TEEPTRAK",
      "updated_at": "Mis à jour à"
    },
    "back": "Retour",
    "calendar_date_format": "DD/MM/YYYY HH:mm",
    "call_example": "Exemple d'appel",
    "configuration": "Configuration",
    "configuration_sessions": {
      "failed": "Sessions échouées",
      "many": "Sessions",
      "one": "Session"
    },
    "consolidated_losses_duration_for_a_machine": "Pertes consolidées",
    "consolidatedloss": "Pertes consolidées",
    "could_not_create": "La création n'a pas aboutie !",
    "could_not_destroy": "La suppression n'a pas aboutie !",
    "could_not_update": "La mise à jour n'a pas aboutie !",
    "csv": "Csv",
    "custom_checkbox_tootltip_text": "Si vous cochez cette case, les pertes non-renseignées seront affichées. Dans le cas contraire, elles seront exclues. Si il y a la présence de pertes non-renseignées dans l'intervalle sélectionné, une requête sera faite toutes les heures pendant 12 heures afin de laisser le temps de renseigner les pertes non-renseignées. A la fin de ce temps, si l'intervalle sélectionné contient toujours des pertes non-renseignées, la réponse sera envoyées avec ces dernières.",
    "custom_form": "Formulaire personnalisé",
    "custom_interval_invalid": "doit avoir des dates valides",
    "custom_interval_validation": "doit être inférieur à un an",
    "customform": "Formulaire personnalisé",
    "daily": "Quotidiennement",
    "dashboard": "Tableau de bord",
    "date": {
      "abbr_day_names": [
        "dim",
        "lun",
        "mar",
        "mer",
        "jeu",
        "ven",
        "sam"
      ],
      "abbr_month_names": [
        null,
        "jan.",
        "fév.",
        "mars",
        "avr.",
        "mai",
        "juin",
        "juil.",
        "août",
        "sept.",
        "oct.",
        "nov.",
        "déc."
      ],
      "day_names": [
        "dimanche",
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "long": "%-d %B %Y",
        "short": "%-d %b"
      },
      "month_names": [
        null,
        "janvier",
        "février",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "août",
        "septembre",
        "octobre",
        "novembre",
        "décembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "environ une heure",
          "other": "environ %{count} heures"
        },
        "about_x_months": {
          "one": "environ un mois",
          "other": "environ %{count} mois"
        },
        "about_x_years": {
          "one": "environ un an",
          "other": "environ %{count} ans"
        },
        "almost_x_years": {
          "one": "presque un an",
          "other": "presque %{count} ans"
        },
        "half_a_minute": "une demi‑minute",
        "less_than_x_minutes": {
          "one": "moins d'une minute",
          "other": "moins de %{count} minutes",
          "zero": "moins d'une minute"
        },
        "less_than_x_seconds": {
          "one": "moins d'une seconde",
          "other": "moins de %{count} secondes",
          "zero": "moins d'une seconde"
        },
        "over_x_years": {
          "one": "plus d'un an",
          "other": "plus de %{count} ans"
        },
        "x_days": {
          "one": "%{count} jour",
          "other": "%{count} jours"
        },
        "x_minutes": {
          "one": "%{count} minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "%{count} mois",
          "other": "%{count} mois"
        },
        "x_seconds": {
          "one": "%{count} seconde",
          "other": "%{count} secondes"
        },
        "x_years": {
          "one": "%{count} an",
          "other": "%{count} ans"
        }
      },
      "prompts": {
        "day": "Jour",
        "hour": "Heure",
        "minute": "Minute",
        "month": "Mois",
        "second": "Seconde",
        "year": "Année"
      }
    },
    "datetime_format": "%d/%m/%Y %H:%M:%S",
    "day": "Jour",
    "defta_custom_one": "Defta personnalisé",
    "defta_custom_two": "Defta personnalisé 2",
    "deftacustomone": "Defta personnalisé",
    "deftacustomtwo": "Defta personnalisé 2",
    "error": "erreur",
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "doit être accepté(e)",
        "blank": "doit être rempli(e)",
        "confirmation": "ne concorde pas avec %{attribute}",
        "empty": "doit être rempli(e)",
        "equal_to": "doit être égal à %{count}",
        "even": "doit être pair",
        "exclusion": "n'est pas disponible",
        "greater_than": "doit être supérieur à %{count}",
        "greater_than_or_equal_to": "doit être supérieur ou égal à %{count}",
        "in": "doit être dans l'intervalle %{count}",
        "inclusion": "n'est pas inclus(e) dans la liste",
        "invalid": "n'est pas valide",
        "less_than": "doit être inférieur à %{count}",
        "less_than_or_equal_to": "doit être inférieur ou égal à %{count}",
        "model_invalid": "Validation échouée : %{errors}",
        "not_a_number": "n'est pas un nombre",
        "not_an_integer": "doit être un nombre entier",
        "odd": "doit être impair",
        "other_than": "doit être différent de %{count}",
        "present": "doit être vide",
        "required": "doit exister",
        "taken": "est déjà utilisé(e)",
        "too_long": {
          "one": "est trop long (pas plus d'un caractère)",
          "other": "est trop long (pas plus de %{count} caractères)"
        },
        "too_short": {
          "one": "est trop court (au moins un caractère)",
          "other": "est trop court (au moins %{count} caractères)"
        },
        "wrong_length": {
          "one": "ne fait pas la bonne longueur (doit comporter un seul caractère)",
          "other": "ne fait pas la bonne longueur (doit comporter %{count} caractères)"
        }
      },
      "template": {
        "body": "Veuillez vérifier les champs suivants : ",
        "header": {
          "one": "Impossible d'enregistrer ce(tte) %{model} : %{count} erreur",
          "other": "Impossible d'enregistrer ce(tte) %{model} : %{count} erreurs"
        }
      }
    },
    "event_feed": "Événements (flux)",
    "eventfeed": "Événements (flux)",
    "events": "Evénements",
    "every": "Tous les",
    "export_destination": "Destination",
    "false": "Non",
    "finished": "fini",
    "flexible_interval_dashboard_performances": "KPIs des tableaux de bords",
    "flexibleintervaldashboard": "KPIs des tableaux de bords",
    "flow_configurations": {
      "container": "Conteneur",
      "created": "La configuration du flow a été enregistrée avec succès !",
      "delete_flow": "Êtes vous sûr ?",
      "destroyed": "La configuration du flow a été supprimée avec succès !",
      "edit": "Editer la configuration du flux",
      "export_destinations": {
        "google_drive": {
          "instructions_html": "Pour que Gate puisse exporter des données vers Google Drive, vous devez créer un <strong>Shared Drive</strong> dans votre Google Drive et le partager avec <strong>%{email}</strong> avec le rôle <i>Content manager</i>. L'ID du dossier est la partie à la fin de l'URL lorsque vous êtes dans le dossier (https://drive.google.com/drive/folders/FOLDER_ID).\n"
        }
      },
      "file_share": "Partage de fichier",
      "form": {
        "actions": "Actions",
        "api": "API",
        "api_information": "Information sur l'API",
        "api_warning": "Les identifiants API vous seront affichés une fois la configuration enregistrée.",
        "authorization_bearer": "Bearer d'autorisation",
        "custom_interval": "Intervalle personnalisé",
        "custom_interval_tooltip": "Une fois le formulaire validé, vous ne pourrez plus modifier l'intervalle personnalisé",
        "day": "Jour",
        "day_number": "Numéro du jour",
        "days": "Jours",
        "destination": "Destination",
        "destination_tooltip": "Sélection du support de réception des données.",
        "display_uninformed_issues": "Affichage des pertes non-renseignées",
        "endpoint": "URL point final",
        "error": {
          "export_destinations": {
            "google_drive_filename": "Nom du fichier Google Drive doit être rempli(e)",
            "google_drive_folder_id": "Dossier Google Drive doit être rempli(e)",
            "microsoft_azure_account_name": "Nom du compte Microsoft Azure doit être rempli(e)",
            "microsoft_azure_connection_string": "Chaîne de connexion Microsoft Azure doit être rempli(e)",
            "microsoft_azure_container_name": "Nom du conteneur Microsoft Azure doit être rempli(e)",
            "microsoft_azure_filename": "Nom du fichier Microsoft Azure doit être rempli(e)",
            "microsoft_azure_folder_name": "Nom du dossier Microsoft Azure doit être rempli(e)",
            "microsoft_azure_share_name": "Nom du partage de fichier Microsoft Azure doit être rempli(e)",
            "microsoft_azure_storage_type": "Type de stockage Microsoft Azure doit être rempli(e)"
          },
          "import_sources": {
            "interval": "Intervalle doit être rempli(e)",
            "teeptrak_dashboard": "Dashboard TEEPTRAK doit être rempli(e)",
            "teeptrak_factory": "L'usine TEEPTRAK ne peut pas être vide",
            "teeptrak_machine": "Machine TEEPTRAK doit être rempli(e)",
            "teeptrak_machines": "Machines TEEPTRAK doit être rempli(e)"
          }
        },
        "frequency_readonly_html": "Les paramètres de fréquence ne peuvent pas être mis à jour une fois la configuration enregistrée.<br />Vous pouvez créer une nouvelle configuration de flux pour modifier la fréquence.",
        "google_drive_filename": "Nom du fichier Google Drive",
        "google_drive_folder_id": "Dossier Google Drive",
        "id": "Référence",
        "interval": "Intervalle",
        "interval_tooltip": "Choix de la période sur laquelle les données sont extraites.",
        "microsoft_azure_account_name": "Nom du compte Microsoft Azure",
        "microsoft_azure_connection_string": "Chaîne de connexion Microsoft Azure",
        "microsoft_azure_container_name": "Nom du conteneur Microsoft Azure",
        "microsoft_azure_filename": "Nom du fichier Microsoft Azure",
        "microsoft_azure_folder_name": "Nom du dossier Microsoft Azure",
        "microsoft_azure_share_name": "Nom du partage de fichier Microsoft Azure",
        "microsoft_azure_storage_type": "Type de stockage Microsoft Azure",
        "name": "Nom",
        "optional_params": "Paramètres optionnels",
        "qualtrak_machine": "Machine Qualtrak",
        "schedule": "Fréquence",
        "schedule_tooltip": "Sélectionnez la fréquence à laquelle l’extraction de données se réalisera.",
        "source": "Source",
        "teeptrak_custom_form": "Formulaire personnalisé TEEPTRAK",
        "teeptrak_dashboard": "Dashboard TEEPTRAK",
        "teeptrak_factory": "Usine TEEPTRAK",
        "teeptrak_import_export_profile": "Profil d'export TEEPTRAK",
        "teeptrak_machine": "Machine TEEPTRAK",
        "teeptrak_machines": "Machines TEEPTRAK",
        "teeptrak_product_names": "Noms des produits TEEPTRAK",
        "time": "Heure",
        "transform_plan": "Plan de transformation",
        "transform_plan_tooltip": "Sélectionnez le type de format sous lequel extraire les données.",
        "type": "Type",
        "type_tooltip": "Choix du type de données à extraire (indicateurs de performance, comptage produit, historique des pertes…).",
        "update_behaviour": "Comportement de mise à jour",
        "user": "Utilisateur"
      },
      "increment_content": "Incrémenter le contenu",
      "index": {
        "actions": "Actions",
        "customer": "Client",
        "id": "Référence",
        "interval": "Intervalle",
        "name": "Nom",
        "schedule": "Planning",
        "time": "Heure",
        "type": "Type",
        "user": "Utilisateur"
      },
      "many": "Configurations de flux",
      "new": "Nouvelle configuration de flux",
      "new_file": "Nouveau fichier",
      "not_set": "Non renseigné",
      "one": "Configuration de flux",
      "replace_with_new_content": "Remplacer avec du nouveau contenu",
      "show": {
        "account_name": "Nom du compte",
        "actions": "Actions",
        "api": "API",
        "authorization_bearer": "Bearer d'autorisation",
        "behaviour": "Comportement",
        "container_name": "Nom du conteneur",
        "csv": "Csv",
        "dashboard_id": "Tableau de bord TEEPTRAK",
        "day": "Jour",
        "day_number": "Jour",
        "days": "Jours",
        "destination": "Destination",
        "endpoint": "URL point final",
        "events_params": {
          "csv_streaming_description_html": "Le format CSV (<code>.csv</code>) transmet toutes les pages en une seule réponse - il suffit d'appeler le point de terminaison une seule fois pour recevoir l'ensemble des données.",
          "csv_streaming_title": "Format CSV",
          "cursor_description": "jeton de pagination de la réponse précédente - passez-le pour obtenir la page suivante",
          "limit_description": "nombre maximum d'événements à renvoyer par demande",
          "pagination_step_1_html": "Définissez <code>depuis</code> comme la date à partir de laquelle vous souhaitez récupérer les événements (obligatoire, format ISO 8601, par exemple <code>2025-01-15T00:00:00Z</code>).",
          "pagination_step_2_html": "Appelez le point final - vous recevrez jusqu'à 2000 événements par page (personnalisable via <code>limite</code>, max 2000).",
          "pagination_step_3_html": "Utilisez l'URL <code>links.next</code> de la réponse pour obtenir la page suivante.",
          "pagination_step_4_html": "Continuez à récupérer la page suivante jusqu'à ce que <code>links.next</code> soit nul - vous avez récupéré tous les événements.",
          "pagination_title": "Comment récupérer des événements (JSON)",
          "parameters_heading": "Paramètres",
          "since_description": "rechercher les événements postérieurs à cette date"
        },
        "factory_id": "Usine TEEPTRAK",
        "feed_params": {
          "bounded_cursor_html": "Le curseur reste alors définitivement associé à cette période. Lorsqu’il n’y a plus de page suivante, ne réutilisez pas ce curseur pour attendre de nouvelles données. Commencez la période suivante en reprenant l’ancien <code>until</code> comme nouveau <code>since</code>.",
          "bounded_intro_html": "Vous pouvez ajouter <code>until</code> pour limiter <code>changes</code> à une période :",
          "bounded_title_html": "Limiter <code>changes</code> à une période",
          "col_code": "Code",
          "col_description": "Description",
          "col_feed": "Flux",
          "col_meaning": "Signification",
          "col_parameter": "Paramètre",
          "col_status": "Statut",
          "col_use": "Utilisation",
          "csv_bounded_html": "Utilisez <code>timeline</code>, ou <code>changes</code> avec <code>until</code>, afin que le téléchargement porte sur une période finie.",
          "csv_description_html": "Remplacez <code>.json</code> par <code>.csv</code> pour que Gate parcoure les pages et transmette progressivement leurs lignes dans un seul fichier.",
          "csv_duration": "Le téléchargement peut prendre plusieurs minutes. S’il est interrompu après son démarrage, le fichier peut être incomplet sans contenir de message d’erreur. Pour un traitement automatisé qui doit contrôler chaque page, préférez le format JSON.",
          "csv_title": "Télécharger un fichier CSV",
          "cursor_fixed": "Les autres réglages, notamment la période, les machines, le fuseau horaire, la langue et les champs personnalisés, sont enregistrés dans le curseur et restent identiques pendant toute la lecture.",
          "cursor_limit_html": "Avec un curseur, seul <code>limit</code> peut être ajouté afin de réduire ou d’augmenter la taille des pages, par exemple après un délai dépassé. Aucun autre paramètre n’est accepté.",
          "cursor_opaque": "Le curseur est opaque : ne le lisez pas et ne le modifiez pas.",
          "cursor_prefer_link_html": "Utilisez de préférence l’URL complète fournie dans <code>links.next</code>. Vous pouvez également envoyer le curseur seul :",
          "cursor_title": "Reprendre avec un curseur",
          "end_changes_bounded": "La période bornée est terminée. Commencez une nouvelle période avec since.",
          "end_changes_bounded_label_html": "<code>changes</code> avec <code>until</code>",
          "end_changes_open": "Aucune autre ligne n’est disponible pour le moment. Conservez le curseur pour le prochain appel.",
          "end_changes_open_label_html": "<code>changes</code> sans <code>until</code>",
          "end_intro": "La fin de lecture n’a pas exactement la même signification selon le flux :",
          "end_timeline": "La période est terminée. Il n’y a plus de curseur à conserver.",
          "end_timeline_label_html": "<code>timeline</code>",
          "error_bad_credentials_html": "Le jeton d’autorisation est absent ou invalide.",
          "error_gateway_html": "TEEPTRAK n’a pas répondu. Rappelez exactement la même URL.",
          "error_invalid_cursor_html": "Le curseur ne peut pas être utilisé sur ce flux. Recommencez avec les paramètres du premier appel.",
          "error_invalid_parameter_html": "Un paramètre est absent, incorrect ou interdit pour cet appel.",
          "error_rate_limit_html": "La limite d’appels est atteinte. Attendez avant de rappeler exactement la même URL.",
          "error_unauthorized_machines_html": "Une ou plusieurs machines ne sont pas accessibles avec ce flux. Leurs identifiants sont indiqués dans <code>details.machine_ids</code>.",
          "errors_intro_html": "Vérifiez toujours le statut HTTP avant de lire la réponse. Les erreurs de paramètres et d’accès aux machines renvoient un objet <code>error</code> contenant <code>code</code>, <code>message</code> et <code>details</code>.",
          "errors_title": "En cas d’erreur",
          "intro": "L’API propose deux façons de parcourir les données. Le choix dépend de ce que vous souhaitez faire.",
          "intro_title_html": "Lire les données avec <code>changes</code> et <code>timeline</code>",
          "limit_description_html": "Nombre de lignes par page, de 1 à 2 000. Valeur par défaut : 2 000.",
          "lost_column_html": "N’utilisez pas <code>started_at</code> ou <code>event_at</code> pour reprendre <code>changes</code>. Comme <code>since</code> est inclus, certaines lignes seront reçues de nouveau : mettez-les à jour à partir de leur <code>id</code>.",
          "lost_precision_html": "Si votre système ne conserve pas toute la précision de <code>updated_at</code>, choisissez une date légèrement antérieure afin de ne pas risquer d’ignorer une ligne.",
          "lost_restart_html": "Recommencez avec un nouveau <code>since</code> égal au dernier <code>updated_at</code> que vous avez traité avec succès.",
          "lost_title": "Si le curseur est perdu",
          "machine_ids_description_html": "Limite la lecture à certaines machines du flux. Jusqu’à 50 identifiants.",
          "machine_ids_example": "Exemple avec plusieurs machines :",
          "order": "Les deux flux renvoient les résultats du plus ancien au plus récent.",
          "order_changes_html": "<code>changes</code> utilise la date de dernière modification, <code>updated_at</code>.",
          "order_timeline_html": "<code>timeline</code> utilise <code>started_at</code> pour les données de production et les pertes, et <code>event_at</code> pour les événements.",
          "parameters_heading": "Paramètres du premier appel",
          "parameters_note_html": "Les dates doivent inclure leur décalage par rapport à UTC, par exemple <code>Z</code> ou <code>+02:00</code>. Dans une URL, écrivez le caractère <code>+</code> sous la forme <code>%2B</code>.",
          "period_bounds_html": "<code>since</code> est inclus et <code>until</code> est exclu. L’exemple ci-dessus couvre donc tout le mois de septembre sans inclure le 1er octobre.",
          "period_chain_first": "première période",
          "period_chain_html": "Pour enchaîner plusieurs périodes sans chevauchement, reprenez la valeur de <code>until</code> comme nouveau <code>since</code> :",
          "period_chain_next": "période suivante",
          "period_done_html": "La lecture de la période est alors terminée et <code>meta.cursor</code> vaut également <code>null</code>.",
          "period_first_call_html": "Le premier appel doit contenir <code>since</code> et <code>until</code> :",
          "period_intro_html": "Utilisez <code>timeline</code> pour un export ou pour lire une période déterminée, par exemple dans Power BI.",
          "period_late_changes_html": "<code>timeline</code> suit la date métier. Une ligne ajoutée ou modifiée après la lecture de sa période peut donc ne pas apparaître lors d’une lecture suivante. Utilisez <code>changes</code> pour récupérer les créations et modifications ultérieures.",
          "period_restart_html": "Si la lecture est interrompue, reprenez avec la dernière URL reçue dans <code>links.next</code>. Si vous ne l’avez pas conservée, recommencez la même période.",
          "period_step_1_html": "appelez le flux avec <code>since</code> et <code>until</code> ;",
          "period_step_2_html": "si <code>links.next</code> contient une URL, appelez cette URL sans la modifier, avec le même en-tête <code>Authorization</code> ;",
          "period_step_3_html": "continuez jusqu’à ce que <code>links.next</code> vaille <code>null</code>.",
          "period_steps_intro": "Pour parcourir la période :",
          "period_title_html": "Lire une période avec <code>timeline</code>",
          "rate_limit": "Respectez au minimum deux secondes entre deux appels, dans la limite de 500 appels par heure et par jeton.",
          "response_count_html": "<code>meta.count</code> indique le nombre de lignes de cette réponse ;",
          "response_cursor_html": "<code>meta.cursor</code> indique la position atteinte après cette réponse.",
          "response_data_html": "<code>data</code> contient les lignes demandées ;",
          "response_has_more_html": "<code>meta.has_more</code> indique si une autre page est disponible immédiatement ;",
          "response_intro": "Une réponse contient les données, l’état de la lecture et, lorsqu’elle existe, l’URL de la page suivante.",
          "response_next_html": "<code>links.next</code> contient l’URL de la page suivante, ou <code>null</code> lorsqu’il n’y en a pas ;",
          "response_title": "Comprendre une réponse JSON",
          "since_description_html": "Date et heure de départ, incluses. Obligatoire. Sur <code>changes</code>, elle s’applique à <code>updated_at</code>. Sur <code>timeline</code>, elle s’applique à la date métier.",
          "sync_checkpoint": "Enregistrez le curseur seulement après avoir traité toutes les lignes de la réponse. Ainsi, une interruption ne vous fera pas ignorer de données.",
          "sync_cursor_kept_html": "Même lorsqu’aucune nouvelle ligne n’est disponible, le curseur de <code>changes</code> reste présent. Il permet de reprendre plus tard au même endroit.",
          "sync_first_call": "Lors du premier appel, indiquez uniquement la date de départ :",
          "sync_intro_html": "Utilisez <code>changes</code> pour récupérer les lignes selon leur date de dernière modification.",
          "sync_step_1_html": "traitez toutes les lignes présentes dans <code>data</code> ;",
          "sync_step_2_html": "suivez <code>links.next</code> tant qu’une page suivante est disponible ;",
          "sync_step_3_html": "lorsque <code>links.next</code> vaut <code>null</code>, conservez la valeur de <code>meta.cursor</code> ;",
          "sync_step_4": "lors du prochain appel, envoyez ce curseur sans le modifier.",
          "sync_steps_intro": "Pour poursuivre la lecture :",
          "sync_title_html": "Lire régulièrement les créations et modifications avec <code>changes</code>",
          "sync_upsert_html": "Une ligne déjà reçue peut revenir avec le même <code>id</code> après une modification. Le client doit donc mettre à jour ses données à partir de cet <code>id</code>. Les lignes supprimées ne sont pas renvoyées par ce flux.",
          "timezone_description_html": "Fuseau utilisé pour afficher les dates, par exemple <code>Europe/Paris</code>. Il ne change pas les données sélectionnées.",
          "until_description_html": "Date et heure de fin, exclues. Obligatoire sur <code>timeline</code> et facultative sur <code>changes</code>.",
          "use_changes": "Lire régulièrement les lignes créées ou modifiées.",
          "use_timeline": "Lire une période finie selon la date métier des données.",
          "value_present": "présent",
          "with_custom_fields_description_html": "Ajoute les champs personnalisés à la réponse. Valeur par défaut : <code>false</code>."
        },
        "feeds_testing_badge": "En test",
        "feeds_testing_notice": "Ces flux sont en cours de test : le format des réponses peut encore évoluer. Prenez contact avec votre interlocuteur TEEPTRAK avant de mettre une intégration en production.",
        "filename": "Nom du fichier",
        "folder_id": "Dossier",
        "folder_name": "Nom du dossier",
        "id": "Référence",
        "interval": "Intervalle",
        "json": "JSON",
        "machine_id": "Machine TEEPTRAK",
        "machine_ids": "Machines TEEPTRAK",
        "method": "Methode",
        "name": "Nom",
        "no_custom_form_founded": "Pas de formulaire personnalisé trouvé",
        "no_factory_found": "Pas d'usine trouvée",
        "no_import_export_profile_founded": "Pas de profil d'export trouvé",
        "no_machine_found": "Pas de machine trouvée",
        "no_product_founded": "Pas de produit trouvé",
        "none": "Aucune transformation",
        "optional_params": {
          "as_many_machine_filters_as_you_want": "ajouter autant de paramètres que de machines à filtrer",
          "boolean": "booléen",
          "column": "Colonne",
          "created_at_gteq_description_content": "supérieur ou égal à",
          "created_at_lteq_description_content": "inférieur ou égal à",
          "date_format": "AAAA-MM-JJ HH:mm:ss",
          "datetime": "date",
          "default": "Défaut",
          "description": "Description",
          "empty": "vide",
          "ended_at_gteq_description_content": "supérieur ou égal à",
          "ended_at_lteq_description_content": "inférieur ou égal à",
          "filter_by_machine_ids_description_content": "filtre par id machine",
          "format": "Format",
          "heading": "Paramètres optionnels",
          "info": "Info",
          "integer": "nombre",
          "maximum": "Maximum",
          "minimum": "Minimum",
          "order_by_shift_started_at": "classez les résultats par date de début d'affectation",
          "order_description_content": "classe les résultats par date de mise à jour",
          "page_description_content": "quel numéro de page à retourner par l'API",
          "page_size_description_content": "combien de résultats par page à retourner par l'API",
          "required": "Exigée",
          "started_at_gteq_description_content": "plus grand ou égal à",
          "started_at_lteq_description_content": "plus petit ou égal à",
          "string": "texte",
          "updated_at_gteq_description_content": "plus grand ou égal à",
          "updated_at_lteq_description_content": "plus petit ou égal à",
          "with_custom_fields_description_content": "autorise l'affichage des champs personnalisés"
        },
        "performance_logs_params": {
          "csv_streaming_description_html": "Le format CSV (<code>.csv</code>) transmet toutes les pages en une seule réponse - il suffit d'appeler le point de terminaison une seule fois pour recevoir l'ensemble des données.",
          "csv_streaming_title": "Format CSV",
          "cursor_description": "jeton de pagination de la réponse précédente - passez-le pour obtenir la page suivante",
          "filters_heading": "Filtres en option",
          "limit_description": "nombre maximum de journaux de performance à renvoyer par requête",
          "machine_ids_description": "filtrer les résultats en fonction d'identifiants de machines spécifiques (sous-ensemble de machines autorisées)",
          "pagination_step_1_html": "Définissez <code>since</code> comme la date à partir de laquelle vous souhaitez récupérer les journaux de performance (obligatoire, format ISO 8601, par exemple <code>2025-01-15T00:00:00Z</code>).",
          "pagination_step_2_html": "Appelez le point final - vous recevrez jusqu'à 2000 enregistrements par page (personnalisable via <code>limite</code>, max 2000).",
          "pagination_step_3_html": "Utilisez l'URL <code>links.next</code> de la réponse pour obtenir la page suivante.",
          "pagination_step_4_html": "Continuez à rechercher la page suivante jusqu'à ce que <code>links.next</code> soit nul - vous avez récupéré tous les enregistrements.",
          "pagination_title": "Comment récupérer les journaux de performance (JSON)",
          "parameters_heading": "Paramètres",
          "range_filter_description": "doit être utilisé conjointement - recherche les enregistrements dont la période de temps chevauche celle de la requête",
          "since_description": "récupérer les journaux de performance mis à jour après cette date",
          "with_custom_fields_description": "inclure les valeurs des champs personnalisés dans la réponse"
        },
        "schedule": "Planning",
        "share_name": "Nom du partage",
        "simplified_losses_v2_params": {
          "csv_streaming_description_html": "Le format CSV (<code>.csv</code>) transmet toutes les pages en une seule réponse - il suffit d'appeler le point de terminaison une seule fois pour recevoir l'ensemble des données.",
          "csv_streaming_title": "Format CSV",
          "cursor_description": "jeton de pagination de la réponse précédente - passez-le pour obtenir la page suivante",
          "filters_heading": "Filtres en option",
          "limit_description": "nombre maximum de pertes simplifiées à renvoyer par demande",
          "machine_ids_description": "filtrer les résultats en fonction d'identifiants de machines spécifiques (sous-ensemble de machines autorisées)",
          "pagination_step_1_html": "Définissez <code>since</code> comme la date à partir de laquelle vous souhaitez récupérer les pertes simplifiées (obligatoire, format ISO 8601, par exemple <code>2025-01-15T00:00:00Z</code>).",
          "pagination_step_2_html": "Appelez le point final - vous recevrez jusqu'à 2000 enregistrements par page (personnalisable via <code>limite</code>, max 2000).",
          "pagination_step_3_html": "Utilisez l'URL <code>links.next</code> de la réponse pour obtenir la page suivante.",
          "pagination_step_4_html": "Continuez à rechercher la page suivante jusqu'à ce que <code>links.next</code> soit nul - vous avez récupéré tous les enregistrements.",
          "pagination_title": "Comment récupérer les pertes simplifiées (JSON)",
          "parameters_heading": "Paramètres",
          "range_filter_description": "doit être utilisé conjointement - recherche les enregistrements dont la période de temps chevauche celle de la requête",
          "since_description": "rechercher les pertes simplifiées mises à jour après cette date",
          "with_custom_fields_description": "inclure les valeurs des champs personnalisés dans la réponse"
        },
        "source": "Source",
        "storage_type": "Type de stockage",
        "time": "Heure",
        "time_zone": "Fuseau horaire",
        "transform_plan": "Plan de transformation",
        "type": "Type",
        "user": "Utilisateur"
      },
      "updated": "La configuration du flow a été mise à jour avec succès !"
    },
    "flow_histories": {
      "created": "Historique de flux enregistré avec succès !",
      "destroyed": "Historique de flux supprimé avec succès !",
      "index": {
        "actions": "Actions",
        "created_at": "Date d'exécution",
        "daterangepicker": {
          "apply_label": "Valider",
          "april": "Avril",
          "august": "Août",
          "cancel_label": "Annuler",
          "december": "Décembre",
          "february": "Février",
          "fr": "Ve",
          "january": "Janvier",
          "july": "Juillet",
          "june": "Juin",
          "march": "Mars",
          "may": "Mai",
          "mo": "Lu",
          "november": "Novembre",
          "october": "Octobre",
          "sa": "Sa",
          "september": "Septembre",
          "su": "Di",
          "th": "Je",
          "tu": "Ma",
          "we": "Me"
        },
        "filter": "Filtrer",
        "flow_configuration": "Configuration de flux",
        "id": "Référence",
        "interval": "Intervalle",
        "no_results_founded": "Pas de résultats trouvés sur la période sélectionnée"
      },
      "many": "Historiques de flux",
      "one": "Historique de flux",
      "show": {
        "Status": "Status",
        "actions": "Actions",
        "flow_configuration": "Configuration de flux",
        "id": "Référence",
        "operator": "Opérateur"
      },
      "updated": "Historique de flux mis à jour avec succès !"
    },
    "friday": "Vendredi",
    "gate_monitoring": "Surveillance des portes",
    "googledrive": "Google Drive",
    "helpers": {
      "select": {
        "prompt": "Veuillez sélectionner"
      },
      "submit": {
        "create": "Créer un(e) %{model}",
        "submit": "Enregistrer ce(tte) %{model}",
        "update": "Modifier ce(tte) %{model}"
      }
    },
    "hi": "Bonjour",
    "home": {
      "show": {
        "actions": "Actions",
        "errors": "Erreurs",
        "exports": "Exports",
        "flow_configuration": "Configuration de flux",
        "id": "Référence",
        "imports": "Imports",
        "in_total": "au total",
        "last_exports": "Derniers exports",
        "last_imports": "Derniers imports",
        "last_week_errors": "Erreurs sur 7 jours",
        "operator": "Operateur",
        "status": "Status",
        "transformations": "Transformations"
      }
    },
    "hour": "Heure",
    "hour_label_tootltip_text": "Si vous choisissez l'heure 00:00 l'extraction se fera sur la journée choisie depuis le matin. Exemple avec le jour de référence &quot;lundi&quot; à 00:00, l'extraction se fera à partir de 00:00 le lundi matin.",
    "hour_label_tootltip_text_FID": "Si vous choisissez l'heure 06:00 l'extraction se fera de la veille à 06:00 jusqu'au jour suivant 06:00.",
    "hourly": "Toutes les heures",
    "hours": "Heures",
    "hutchinson_custom_one": "Hutchinson personnalisé",
    "hutchinsoncustomone": "Hutchinson personnalisé",
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      },
      "transliterate": {
        "rule": {
          "À": "A",
          "Â": "A",
          "Æ": "Ae",
          "Ç": "C",
          "È": "E",
          "É": "E",
          "Ê": "E",
          "Ë": "E",
          "Î": "I",
          "Ï": "I",
          "Ô": "O",
          "Ù": "U",
          "Û": "U",
          "Ü": "U",
          "à": "a",
          "â": "a",
          "æ": "ae",
          "ç": "c",
          "è": "e",
          "é": "e",
          "ê": "e",
          "ë": "e",
          "î": "i",
          "ï": "i",
          "ô": "o",
          "ù": "u",
          "û": "u",
          "ü": "u",
          "ÿ": "y",
          "Œ": "Oe",
          "œ": "oe",
          "Ÿ": "Y"
        }
      }
    },
    "import_export_profile": "Profil d'export",
    "in_progress": "en cours",
    "interval": {
      "a_week_ago": "La semaine dernière",
      "custom_interval": "Intervalle personnalisé",
      "last_12_hours": "Les 12 dernières heures",
      "last_21_days": "Les 21 derniers jours",
      "last_24_hours": "Les 24 dernières heures",
      "last_2_hours": "Les 2 dernières heures",
      "last_30_days": "Les 30 derniers jours",
      "last_6_hours": "Les 6 dernières heures",
      "last_7_days": "Les 7 derniers jours",
      "last_8_hours": "Les 8 dernières heures",
      "last_day": "Le dernier jour",
      "last_hour": "La dernière heure",
      "last_month": "Le mois dernier"
    },
    "json": "JSON",
    "logout": "Déconnexion",
    "machineproductcount": "Comptages produit",
    "merck_custom_one": "Merck sur mesure",
    "merckcustomone": "Merck sur mesure",
    "microsoftazure": "Microsoft Azure",
    "monday": "Lundi",
    "monitoring": "Contrôle",
    "month": "Mois",
    "monthly": "Mensuellement",
    "new_account_could_not_be_saved": "Impossible de créer un nouveau compte",
    "next": "Suivant",
    "no_transformation": "Aucune transformation",
    "not_finished": "Non finie",
    "nth_each_month": "de chaque mois",
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 3,
        "round_mode": "default",
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "milliard",
            "million": "million",
            "quadrillion": "million de milliards",
            "thousand": "millier",
            "trillion": "billion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "octet",
              "other": "octets"
            },
            "eb": "Eo",
            "gb": "Go",
            "kb": "ko",
            "mb": "Mo",
            "pb": "Po",
            "tb": "To"
          }
        }
      },
      "nth": {},
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "operation_not_found": "L'opération demandée n'a pas été retrouvée !",
    "operations": {
      "one": "Operation",
      "show": {
        "content": "Contenu",
        "created_at": "Date de création",
        "errors": "Erreurs",
        "finished_at": "Fini à",
        "flow": "Configuration de flux",
        "id": "Référence",
        "informations": "Informations",
        "initiator": "Initiateur",
        "logs": "Historique des logs",
        "name": "Nom",
        "no_errors": "Pas d'erreurs",
        "partial_coverage": {
          "summary": "L'export a livré cette fenêtre, mais la plateforme n'a pas pu la calculer pour les machines ci-dessous. Leurs données manquent dans le fichier, et leurs périodes ne sont pas vides.",
          "title": "Des machines manquent dans cet export"
        },
        "processed_files": "Fichiers traités",
        "started_at": "Commencé à",
        "status": "Status",
        "undeliverable_export": {
          "covered_from": "Couverte à partir du",
          "machine": "Machine",
          "platform_error": "Signalé par la plateforme",
          "range": "du %{started_at} au %{ended_at}",
          "reason": "Raison",
          "reasons": {
            "no_loss_configuration": "Aucune configuration des pertes n'est affectée à cette machine. Affectez-lui une configuration pour que la plateforme puisse calculer cette fenêtre.",
            "no_pace_cause_configuration": "Aucune configuration des causes de cadence n'est affectée à cette machine. Affectez-lui une configuration pour que la plateforme puisse calculer cette fenêtre.",
            "no_shift_configuration": "Aucune configuration des équipes n'est affectée à cette machine. Affectez-lui une configuration pour que la plateforme puisse calculer cette fenêtre.",
            "no_shift_schedule_in_range": "La configuration des équipes de cette machine ne place aucune équipe dans cette fenêtre. Étendez-la sur cette fenêtre, ou réglez le flux sur une fenêtre qu'elle couvre.",
            "range_starts_before_shift_configuration": "La fenêtre commence avant la date de début de la configuration des équipes de cette machine. Avancez cette date de début, ou réglez le flux sur une fenêtre qui commence à cette date ou plus tard.",
            "shift_configuration_has_unassigned_duration": "La configuration des équipes de cette machine laisse des périodes sans équipe, ses durées ne couvrent donc pas tout son cycle. Complétez les périodes manquantes.",
            "shift_configuration_not_anchored": "La configuration des équipes de cette machine n'a pas de date de début. Renseignez une date de début antérieure ou égale au début de cette fenêtre."
          },
          "summary": "La plateforme n'a pas pu calculer cette fenêtre, l'export n'a donc rien livré pour cette période. Cette période n'est pas vide.",
          "title": "Aucune donnée livrée pour cette fenêtre",
          "uncovered_machines": "Machines non couvertes",
          "utc_timestamp": "%{timestamp} UTC",
          "window": "Fenêtre"
        }
      }
    },
    "pace_defta_custom_one": "PACETRAK Defta personnalisé",
    "pacedeftacustomone": "PACETRAK Defta personnalisé",
    "pending": "en attente",
    "per_shift": "Par équipe",
    "perf_cycletime_product": "Produits PerfTrak à temps de cycle",
    "perf_startstop_product": "Produits PerfTrak marche/arrêt",
    "perfcycletimeproduct": "Produits PerfTrak à temps de cycle",
    "performance_log": "Journaux de performance (v2)",
    "performance_log_feed": "Journaux de performance (flux)",
    "performancelogfeed": "Journaux de performance (flux)",
    "perfstartstopproduct": "Produits PerfTrak marche/arrêt",
    "please_choose_a_custom_interval": "Choisir un intervalle",
    "please_choose_an_option": "Choisir une option",
    "please_choose_the_desired_export_destination": "Merci de choisir une destination",
    "please_choose_the_desired_source": "Merci de choisir une source",
    "please_choose_the_desired_transform_plan": "Merci de choisir un plan de transformation",
    "please_fill_in_the_form_below": "Merci de remplir le formulaire ci-dessous",
    "please_review_the_errors_below": "Merci de corriger les erreurs suivantes",
    "powered_by_teeptrak": "powered by TEEPTRAK",
    "privacy_policy": "Confidentialité des données",
    "product_counts_for_a_machine": "Comptages produit",
    "product_name_label_tootltip_text": "La sélection des produits est facultative.",
    "production_order_line": "Ordres de production",
    "productionorderline": "Ordres de production",
    "qual_hutchinson_custom_one": "Qualtrak Hutchinson personnalisé",
    "qualhutchinsoncustomone": "Qualtrak Hutchinson personnalisé",
    "quartly": "Toutes les 15 mn",
    "raw_data": "Données brutes (obsolète)",
    "rawdata": "Données brutes (obsolète)",
    "required": "Nécessaire",
    "saturday": "Samedi",
    "save_form": "Enregister le flux",
    "savencia_custom_one": "Savencia personnalisé",
    "savenciacustomone": "Savencia personnalisé",
    "server_alibaba_shanghai": "Server located in Shanghai",
    "server_alibaba_shenzhen": "Server located in Shenzhen",
    "server_ovh": "Servers located in Europe",
    "shiftly": "Par équipe",
    "simple_form": {
      "error_notification": {
        "default_message": "Veuillez examiner les problèmes ci-dessous:"
      },
      "labels": {
        "configuration": {
          "cron": "Planning",
          "day": "Jour",
          "day_number": "Jour",
          "days": "Jours",
          "name": "Nom",
          "time": "Heure"
        },
        "import_source": {
          "interval": "Intevalle",
          "type": "Type"
        }
      },
      "non": "Non",
      "oui": "Oui",
      "required": {
        "mark": "*",
        "text": "Nécessaire"
      }
    },
    "simplified_loss_feed": "Pertes simplifiées (flux)",
    "simplified_loss_v2": "Pertes simplifiées (v2)",
    "simplified_losses": {
      "maximum_requests": "Vous avez fait trop de requêtes en une heure. Vous devez attendre %{maximum_requests} heures pour faire de nouvelles requêtes.",
      "time_before_next_request": "Trop de requêtes simultanées. Veuillez attendre %{time_before_next_request} secondes."
    },
    "simplified_losses_duration_for_a_machine": "Pertes simplifiées (obsolète)",
    "simplifiedloss": "Pertes simplifiées (obsolète)",
    "simplifiedlossfeed": "Pertes simplifiées (flux)",
    "simplifiedlossv2": "Pertes simplifiées (v2)",
    "solina_custom_one": "SOLINA personnalisé",
    "solina_custom_two": "SOLINA personnalisé (2)",
    "solinacustomone": "SOLINA personnalisé",
    "solinacustomtwo": "SOLINA personnalisé (2)",
    "source": "Source",
    "sunday": "Dimanche",
    "support": {
      "array": {
        "last_word_connector": " et ",
        "two_words_connector": " et ",
        "words_connector": ", "
      }
    },
    "thursday": "Jeudi",
    "time": {
      "am": "am",
      "formats": {
        "default": "%d %B %Y %Hh %Mmin %Ss",
        "long": "%A %d %B %Y %Hh%M",
        "short": "%d %b %Hh%M"
      },
      "pm": "pm"
    },
    "total_of": "Total de",
    "transform_plan": "Plan de transformation",
    "true": "Oui",
    "tuesday": "Mardi",
    "type": "Type",
    "views": {
      "pagination": {
        "first": "« Première",
        "last": "Dernière »",
        "next": "Suivante ›",
        "previous": "‹ Précédente",
        "truncate": "..."
      }
    },
    "wednesday": "Mercredi",
    "week": "Semaine",
    "weekly": "Hebdomadairement",
    "welcome_to_teeptrak_gate": "Bienvenue à TEEPTRAK Gate"
  },
  "zh-CN": {
    "activated_tootltip_text": "如果停用配置，您将不再收到数据。",
    "activerecord": {
      "attributes": {
        "configuration": {
          "import_sources": "数据类型",
          "name": "名称",
          "time_zone": "时区",
          "transform_plan": "转换配置"
        },
        "export_destinations": {
          "google_drive_filename": "Google Drive文件名",
          "google_drive_folder_id": "Google Drive文件夹",
          "microsoft_azure_account_name": "Nom du compte Microsoft Azure",
          "microsoft_azure_connection_string": "Chaîne de connexion Microsoft Azure",
          "microsoft_azure_container_name": "Nom du conteneur Microsoft Azure",
          "microsoft_azure_credentials": "账户名称或访问密钥错误",
          "microsoft_azure_filename": "Nom du fichier Microsoft Azure",
          "microsoft_azure_folder_name": "Nom du dossier Microsoft Azure",
          "microsoft_azure_share_name": "Nom du partage de fichier Microsoft Azure",
          "microsoft_azure_storage_type": "Type de stockage Microsoft Azure"
        },
        "import_sources": {
          "interval": "间隔",
          "teeptrak_dashboard_id": "Teeptrak控制面板",
          "teeptrak_factory_id": "Teeptrak工厂"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "验证失败：%{errors}",
          "restrict_dependent_destroy": {
            "has_many": "由于%{record}需要此记录，所以无法移除记录",
            "has_one": "由于%{record}需要此记录，所以无法移除记录"
          }
        }
      }
    },
    "api": "API",
    "attributes": {
      "activated": "活性",
      "created_at": "创建于",
      "deactivated": "关闭",
      "shift_started_at": "轮班开始于",
      "started_at": "开始于",
      "teeptrak_machine_ids": "Teeptrak 机器",
      "updated_at": "更新于"
    },
    "back": "返回",
    "calendar_date_format": "日日/月月/年年年年",
    "call_example": "例子",
    "configuration": "配置",
    "configuration_sessions": {
      "failed": "失败的会议",
      "many": "会议",
      "one": "会议"
    },
    "consolidated_losses_duration_for_a_machine": "统计的损失数据",
    "consolidatedloss": "统计的损失数据",
    "could_not_create": "注册失败",
    "could_not_destroy": "删除失败",
    "could_not_update": "更新失败",
    "csv": "CSV",
    "custom_checkbox_tootltip_text": "如果你勾选此框,未列出的损失将被显示。如果没有,他们将被排除在外。如果在选定的区间内有下落不明的损失,将在12小时内每小时进行一次查询,以便有时间填入下落不明的损失。在这段时间结束时,如果所选区间仍包含未计算的损失,则将发送带有这些损失的回复。",
    "custom_form": "自定义表单",
    "custom_interval_invalid": "日期必须有效",
    "custom_interval_validation": "必须在一年以内",
    "customform": "自定义表单",
    "daily": "每日",
    "dashboard": "控制面板",
    "date": {
      "abbr_day_names": [
        "周日",
        "周一",
        "周二",
        "周三",
        "周四",
        "周五",
        "周六"
      ],
      "abbr_month_names": [
        null,
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月"
      ],
      "day_names": [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%Y年%m月%d日",
        "short": "%m月%d日"
      },
      "month_names": [
        null,
        "一月",
        "二月",
        "三月",
        "四月",
        "五月",
        "六月",
        "七月",
        "八月",
        "九月",
        "十月",
        "十一月",
        "十二月"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": "大约%{count}小时",
        "about_x_months": "大约%{count}个月",
        "about_x_years": "大约%{count}年",
        "almost_x_years": "接近%{count}年",
        "half_a_minute": "半分钟",
        "less_than_x_minutes": "不到%{count}分钟",
        "less_than_x_seconds": "不到%{count}秒",
        "over_x_years": "%{count}年多",
        "x_days": "%{count}天",
        "x_minutes": "%{count}分钟",
        "x_months": "%{count}个月",
        "x_seconds": "%{count}秒",
        "x_years": "%{count}年"
      },
      "prompts": {
        "day": "日",
        "hour": "时",
        "minute": "分",
        "month": "月",
        "second": "秒",
        "year": "年"
      }
    },
    "datetime_format": "%m/%d/%Y %H:%M",
    "day": "日",
    "defta_custom_one": "定制",
    "defta_custom_two": "定制 2",
    "deftacustomone": "定制",
    "deftacustomtwo": "定制 2",
    "error": "错误",
    "errors": {
      "format": "%{attribute}%{message}",
      "messages": {
        "accepted": "必须是可被接受的",
        "blank": "不能为空字符",
        "confirmation": "与%{attribute}不匹配",
        "empty": "不能留空",
        "equal_to": "必须等于%{count}",
        "even": "必须为双数",
        "exclusion": "是保留关键字",
        "greater_than": "必须大于%{count}",
        "greater_than_or_equal_to": "必须大于或等于%{count}",
        "in": "doit être dans l'intervalle %{count}",
        "inclusion": "不包含于列表中",
        "invalid": "是无效的",
        "less_than": "必须小于%{count}",
        "less_than_or_equal_to": "必须小于或等于%{count}",
        "model_invalid": "验证失败：%{errors}",
        "not_a_number": "不是数字",
        "not_an_integer": "必须是整数",
        "odd": "必须为单数",
        "other_than": "长度非法（不可为%{count}个字符）",
        "present": "必须是空白",
        "required": "必须存在",
        "taken": "已经被使用",
        "too_long": "过长（最长为%{count}个字符）",
        "too_short": "过短（最短为%{count}个字符）",
        "wrong_length": "长度非法（必须为%{count}个字符）"
      },
      "template": {
        "body": "如下字段出现错误：",
        "header": "有%{count}个错误发生导致“%{model}”无法被保存。"
      }
    },
    "event_feed": "Événements (flux)",
    "eventfeed": "Événements (flux)",
    "events": "活动",
    "every": "每一个",
    "export_destination": "目标文件",
    "false": "假",
    "finished": "已完成",
    "flexible_interval_dashboard_performances": "控制面板KPI指标",
    "flexibleintervaldashboard": "控制面板KPI指标",
    "flow_configurations": {
      "container": "集装箱",
      "created": "注册成功！",
      "delete_flow": "请确认",
      "destroyed": "删除成功！",
      "edit": "编辑配置",
      "export_destinations": {
        "google_drive": {
          "instructions_html": "要将数据导出到 Google Drive，Gate 必须在 Google Drive 中创建<strong>共享驱动器</strong> ，并与<strong>%{email}</strong> 和<i>内容管理器</i> 角色共享。文件夹 ID 是进入文件夹 (https://drive.google.com/drive/folders/FOLDER_ID) 时 URL 末尾的部分。\n"
        }
      },
      "file_share": "文件共享",
      "form": {
        "actions": "行动",
        "api": "API",
        "api_information": "关于API的信息",
        "api_warning": "一旦配置被保存,将显示API凭证",
        "authorization_bearer": "授权书持有者",
        "custom_interval": "自定义间隔",
        "custom_interval_tooltip": "一旦表单通过验证，您将无法更改自定义时间间隔。",
        "day": "日",
        "day_number": "日",
        "days": "日",
        "destination": "下载到",
        "destination_tooltip": "数据接收介质的选择",
        "display_uninformed_issues": "显示未通知的损失",
        "endpoint": "URL",
        "error": {
          "export_destinations": {
            "google_drive_filename": "必须填写Google Drive文件的名称",
            "google_drive_folder_id": "必须填写Google Drive文件夹",
            "microsoft_azure_account_name": "Microsoft Azure 帐户名不能为空",
            "microsoft_azure_connection_string": "Microsoft Azure 连接字符串不能为空",
            "microsoft_azure_container_name": "Microsoft Azure 容器名称不能为空",
            "microsoft_azure_filename": "Microsoft Azure 文件名不能为空",
            "microsoft_azure_folder_name": "Microsoft Azure 文件夹名称不能为空",
            "microsoft_azure_share_name": "Microsoft Azure 文件共享名称不能为空",
            "microsoft_azure_storage_type": "Microsoft Azure 存储类型不能为空"
          },
          "import_sources": {
            "interval": "必须填写间隔",
            "teeptrak_dashboard": "必须填写Teeptrak控制面板",
            "teeptrak_factory": "TEEPTRAK 工厂不能为空白",
            "teeptrak_machine": "必须填写Teeptrak机器",
            "teeptrak_machines": "TEEPTRAK 机器不能是空白的"
          }
        },
        "frequency_readonly_html": "Les paramètres de fréquence ne peuvent pas être mis à jour une fois la configuration enregistrée.<br />Vous pouvez créer une nouvelle configuration de flux pour modifier la fréquence.",
        "google_drive_filename": "Google Drive 文件夹名称",
        "google_drive_folder_id": "Google Drive 文件夹",
        "id": "id",
        "interval": "间隔",
        "interval_tooltip": "选择提取数据的时期",
        "microsoft_azure_account_name": "Microsoft Azure 帐户名",
        "microsoft_azure_connection_string": "Microsoft Azure 连接字符串",
        "microsoft_azure_container_name": "Microsoft Azure 容器名称",
        "microsoft_azure_filename": "Microsoft Azure 文件名",
        "microsoft_azure_folder_name": "Microsoft Azure 文件夹名称",
        "microsoft_azure_share_name": "Microsoft Azure 文件共享名称",
        "microsoft_azure_storage_type": "Microsoft Azure 存储类型",
        "name": "名称",
        "optional_params": "可选参数",
        "qualtrak_machine": "Machine Qualtrak",
        "schedule": "频次",
        "schedule_tooltip": "选择执行数据提取的频次",
        "source": "数据来源",
        "teeptrak_custom_form": "Teeptrak 自定义报表",
        "teeptrak_dashboard": "Teeptrak 控制面板",
        "teeptrak_factory": "Teeptrak 工厂",
        "teeptrak_import_export_profile": "TEEPTRAK 出口概况",
        "teeptrak_machine": "Teeptrak 机器",
        "teeptrak_machines": "TEEPTRAK 机器",
        "teeptrak_product_names": "Teeptrak 产品名称",
        "time": "时间",
        "transform_plan": "转型计划",
        "transform_plan_tooltip": "选择提取数据的格式类型",
        "type": "类型",
        "type_tooltip": "选择要提取的数据类型（绩效指标、产品计数、损失历史，等等）",
        "update_behaviour": "行为更新",
        "user": "用户"
      },
      "increment_content": "递增的内容",
      "index": {
        "actions": "行动",
        "customer": "客户",
        "id": "id",
        "interval": "间隔",
        "name": "名称",
        "schedule": "规划",
        "time": "时间",
        "type": "类型",
        "user": "用户"
      },
      "many": "配置",
      "new": "增加",
      "new_file": "新文件夹",
      "not_set": "Non renseigné",
      "one": "配置",
      "replace_with_new_content": "用新的内容取代",
      "show": {
        "account_name": "账户名称",
        "actions": "行动",
        "api": "API",
        "authorization_bearer": "授权书持有者",
        "behaviour": "行为",
        "container_name": "容器名称",
        "csv": "CSV",
        "dashboard_id": "TEEPTRAK 控制面板",
        "day": "日",
        "day_number": "日",
        "days": "日",
        "destination": "下载到",
        "endpoint": "URL",
        "events_params": {
          "csv_streaming_description_html": "CSV 格式 (<code>.csv</code>) 在单个响应中流式传输所有页面--只需调用一次端点即可接收完整的数据集。",
          "csv_streaming_title": "CSV 格式",
          "cursor_description": "上一次响应的分页标记 - 通过它来获取下一页面",
          "limit_description": "每次请求返回事件的最大数量",
          "pagination_step_1_html": "将<code>自</code> 设置为要检索事件的日期（必填，ISO 8601 格式，例如<code>2025-01-15T00:00:00Z</code>)",
          "pagination_step_2_html": "调用端点 - 每页最多可接收 2000 个事件（可通过<code>limit</code> 进行自定义，最多 2000 个）。",
          "pagination_step_3_html": "使用回复中的<code>links.next</code> URL 获取下一页面",
          "pagination_step_4_html": "继续获取下一页，直到<code>links.next</code> 为空 - 您已获取了所有事件",
          "pagination_title": "如何检索事件（JSON）",
          "parameters_heading": "参数",
          "since_description": "获取此日期之后的事件"
        },
        "factory_id": "Teeptrak工厂",
        "feed_params": {
          "bounded_cursor_html": "Le curseur reste alors définitivement associé à cette période. Lorsqu’il n’y a plus de page suivante, ne réutilisez pas ce curseur pour attendre de nouvelles données. Commencez la période suivante en reprenant l’ancien <code>until</code> comme nouveau <code>since</code>.",
          "bounded_intro_html": "Vous pouvez ajouter <code>until</code> pour limiter <code>changes</code> à une période :",
          "bounded_title_html": "Limiter <code>changes</code> à une période",
          "col_code": "Code",
          "col_description": "Description",
          "col_feed": "Flux",
          "col_meaning": "Signification",
          "col_parameter": "Paramètre",
          "col_status": "Statut",
          "col_use": "Utilisation",
          "csv_bounded_html": "Utilisez <code>timeline</code>, ou <code>changes</code> avec <code>until</code>, afin que le téléchargement porte sur une période finie.",
          "csv_description_html": "Remplacez <code>.json</code> par <code>.csv</code> pour que Gate parcoure les pages et transmette progressivement leurs lignes dans un seul fichier.",
          "csv_duration": "Le téléchargement peut prendre plusieurs minutes. S’il est interrompu après son démarrage, le fichier peut être incomplet sans contenir de message d’erreur. Pour un traitement automatisé qui doit contrôler chaque page, préférez le format JSON.",
          "csv_title": "Télécharger un fichier CSV",
          "cursor_fixed": "Les autres réglages, notamment la période, les machines, le fuseau horaire, la langue et les champs personnalisés, sont enregistrés dans le curseur et restent identiques pendant toute la lecture.",
          "cursor_limit_html": "Avec un curseur, seul <code>limit</code> peut être ajouté afin de réduire ou d’augmenter la taille des pages, par exemple après un délai dépassé. Aucun autre paramètre n’est accepté.",
          "cursor_opaque": "Le curseur est opaque : ne le lisez pas et ne le modifiez pas.",
          "cursor_prefer_link_html": "Utilisez de préférence l’URL complète fournie dans <code>links.next</code>. Vous pouvez également envoyer le curseur seul :",
          "cursor_title": "Reprendre avec un curseur",
          "end_changes_bounded": "La période bornée est terminée. Commencez une nouvelle période avec since.",
          "end_changes_bounded_label_html": "<code>changes</code> avec <code>until</code>",
          "end_changes_open": "Aucune autre ligne n’est disponible pour le moment. Conservez le curseur pour le prochain appel.",
          "end_changes_open_label_html": "<code>changes</code> sans <code>until</code>",
          "end_intro": "La fin de lecture n’a pas exactement la même signification selon le flux :",
          "end_timeline": "La période est terminée. Il n’y a plus de curseur à conserver.",
          "end_timeline_label_html": "<code>timeline</code>",
          "error_bad_credentials_html": "Le jeton d’autorisation est absent ou invalide.",
          "error_gateway_html": "TEEPTRAK n’a pas répondu. Rappelez exactement la même URL.",
          "error_invalid_cursor_html": "Le curseur ne peut pas être utilisé sur ce flux. Recommencez avec les paramètres du premier appel.",
          "error_invalid_parameter_html": "Un paramètre est absent, incorrect ou interdit pour cet appel.",
          "error_rate_limit_html": "La limite d’appels est atteinte. Attendez avant de rappeler exactement la même URL.",
          "error_unauthorized_machines_html": "Une ou plusieurs machines ne sont pas accessibles avec ce flux. Leurs identifiants sont indiqués dans <code>details.machine_ids</code>.",
          "errors_intro_html": "Vérifiez toujours le statut HTTP avant de lire la réponse. Les erreurs de paramètres et d’accès aux machines renvoient un objet <code>error</code> contenant <code>code</code>, <code>message</code> et <code>details</code>.",
          "errors_title": "En cas d’erreur",
          "intro": "L’API propose deux façons de parcourir les données. Le choix dépend de ce que vous souhaitez faire.",
          "intro_title_html": "Lire les données avec <code>changes</code> et <code>timeline</code>",
          "limit_description_html": "Nombre de lignes par page, de 1 à 2 000. Valeur par défaut : 2 000.",
          "lost_column_html": "N’utilisez pas <code>started_at</code> ou <code>event_at</code> pour reprendre <code>changes</code>. Comme <code>since</code> est inclus, certaines lignes seront reçues de nouveau : mettez-les à jour à partir de leur <code>id</code>.",
          "lost_precision_html": "Si votre système ne conserve pas toute la précision de <code>updated_at</code>, choisissez une date légèrement antérieure afin de ne pas risquer d’ignorer une ligne.",
          "lost_restart_html": "Recommencez avec un nouveau <code>since</code> égal au dernier <code>updated_at</code> que vous avez traité avec succès.",
          "lost_title": "Si le curseur est perdu",
          "machine_ids_description_html": "Limite la lecture à certaines machines du flux. Jusqu’à 50 identifiants.",
          "machine_ids_example": "Exemple avec plusieurs machines :",
          "order": "Les deux flux renvoient les résultats du plus ancien au plus récent.",
          "order_changes_html": "<code>changes</code> utilise la date de dernière modification, <code>updated_at</code>.",
          "order_timeline_html": "<code>timeline</code> utilise <code>started_at</code> pour les données de production et les pertes, et <code>event_at</code> pour les événements.",
          "parameters_heading": "Paramètres du premier appel",
          "parameters_note_html": "Les dates doivent inclure leur décalage par rapport à UTC, par exemple <code>Z</code> ou <code>+02:00</code>. Dans une URL, écrivez le caractère <code>+</code> sous la forme <code>%2B</code>.",
          "period_bounds_html": "<code>since</code> est inclus et <code>until</code> est exclu. L’exemple ci-dessus couvre donc tout le mois de septembre sans inclure le 1er octobre.",
          "period_chain_first": "première période",
          "period_chain_html": "Pour enchaîner plusieurs périodes sans chevauchement, reprenez la valeur de <code>until</code> comme nouveau <code>since</code> :",
          "period_chain_next": "période suivante",
          "period_done_html": "La lecture de la période est alors terminée et <code>meta.cursor</code> vaut également <code>null</code>.",
          "period_first_call_html": "Le premier appel doit contenir <code>since</code> et <code>until</code> :",
          "period_intro_html": "Utilisez <code>timeline</code> pour un export ou pour lire une période déterminée, par exemple dans Power BI.",
          "period_late_changes_html": "<code>timeline</code> suit la date métier. Une ligne ajoutée ou modifiée après la lecture de sa période peut donc ne pas apparaître lors d’une lecture suivante. Utilisez <code>changes</code> pour récupérer les créations et modifications ultérieures.",
          "period_restart_html": "Si la lecture est interrompue, reprenez avec la dernière URL reçue dans <code>links.next</code>. Si vous ne l’avez pas conservée, recommencez la même période.",
          "period_step_1_html": "appelez le flux avec <code>since</code> et <code>until</code> ;",
          "period_step_2_html": "si <code>links.next</code> contient une URL, appelez cette URL sans la modifier, avec le même en-tête <code>Authorization</code> ;",
          "period_step_3_html": "continuez jusqu’à ce que <code>links.next</code> vaille <code>null</code>.",
          "period_steps_intro": "Pour parcourir la période :",
          "period_title_html": "Lire une période avec <code>timeline</code>",
          "rate_limit": "Respectez au minimum deux secondes entre deux appels, dans la limite de 500 appels par heure et par jeton.",
          "response_count_html": "<code>meta.count</code> indique le nombre de lignes de cette réponse ;",
          "response_cursor_html": "<code>meta.cursor</code> indique la position atteinte après cette réponse.",
          "response_data_html": "<code>data</code> contient les lignes demandées ;",
          "response_has_more_html": "<code>meta.has_more</code> indique si une autre page est disponible immédiatement ;",
          "response_intro": "Une réponse contient les données, l’état de la lecture et, lorsqu’elle existe, l’URL de la page suivante.",
          "response_next_html": "<code>links.next</code> contient l’URL de la page suivante, ou <code>null</code> lorsqu’il n’y en a pas ;",
          "response_title": "Comprendre une réponse JSON",
          "since_description_html": "Date et heure de départ, incluses. Obligatoire. Sur <code>changes</code>, elle s’applique à <code>updated_at</code>. Sur <code>timeline</code>, elle s’applique à la date métier.",
          "sync_checkpoint": "Enregistrez le curseur seulement après avoir traité toutes les lignes de la réponse. Ainsi, une interruption ne vous fera pas ignorer de données.",
          "sync_cursor_kept_html": "Même lorsqu’aucune nouvelle ligne n’est disponible, le curseur de <code>changes</code> reste présent. Il permet de reprendre plus tard au même endroit.",
          "sync_first_call": "Lors du premier appel, indiquez uniquement la date de départ :",
          "sync_intro_html": "Utilisez <code>changes</code> pour récupérer les lignes selon leur date de dernière modification.",
          "sync_step_1_html": "traitez toutes les lignes présentes dans <code>data</code> ;",
          "sync_step_2_html": "suivez <code>links.next</code> tant qu’une page suivante est disponible ;",
          "sync_step_3_html": "lorsque <code>links.next</code> vaut <code>null</code>, conservez la valeur de <code>meta.cursor</code> ;",
          "sync_step_4": "lors du prochain appel, envoyez ce curseur sans le modifier.",
          "sync_steps_intro": "Pour poursuivre la lecture :",
          "sync_title_html": "Lire régulièrement les créations et modifications avec <code>changes</code>",
          "sync_upsert_html": "Une ligne déjà reçue peut revenir avec le même <code>id</code> après une modification. Le client doit donc mettre à jour ses données à partir de cet <code>id</code>. Les lignes supprimées ne sont pas renvoyées par ce flux.",
          "timezone_description_html": "Fuseau utilisé pour afficher les dates, par exemple <code>Europe/Paris</code>. Il ne change pas les données sélectionnées.",
          "until_description_html": "Date et heure de fin, exclues. Obligatoire sur <code>timeline</code> et facultative sur <code>changes</code>.",
          "use_changes": "Lire régulièrement les lignes créées ou modifiées.",
          "use_timeline": "Lire une période finie selon la date métier des données.",
          "value_present": "présent",
          "with_custom_fields_description_html": "Ajoute les champs personnalisés à la réponse. Valeur par défaut : <code>false</code>."
        },
        "feeds_testing_badge": "En test",
        "feeds_testing_notice": "Ces flux sont en cours de test : le format des réponses peut encore évoluer. Prenez contact avec votre interlocuteur TEEPTRAK avant de mettre une intégration en production.",
        "filename": "名称",
        "folder_id": "文件夹",
        "folder_name": "文件夹名称",
        "id": "id",
        "interval": "间隔",
        "json": "JSON",
        "machine_id": "Teeptrak机器",
        "machine_ids": "TEEPTRAK 机器",
        "method": "方法",
        "name": "名称",
        "no_custom_form_founded": "没有找到自定义表单",
        "no_factory_found": "没有找到工厂",
        "no_import_export_profile_founded": "未建立导出配置文件",
        "no_machine_found": "没有找到机器",
        "no_product_founded": "没有找到产品",
        "none": "没有转型",
        "optional_params": {
          "as_many_machine_filters_as_you_want": "根据要过滤的机器数量添加参数",
          "boolean": "布尔",
          "column": "栏目",
          "created_at_gteq_description_content": "大于或等于",
          "created_at_lteq_description_content": "小于或等于",
          "date_format": "年年年年/月月/日日",
          "datetime": "日期",
          "default": "默认值",
          "description": "描述",
          "empty": "空",
          "ended_at_gteq_description_content": "大于或等于",
          "ended_at_lteq_description_content": "小于或等于",
          "filter_by_machine_ids_description_content": "按机器 ID 过滤",
          "format": "格式",
          "heading": "可选参数",
          "info": "信息",
          "integer": "数据",
          "maximum": "最大",
          "minimum": "最小值",
          "order_by_shift_started_at": "按轮班开始日期排序",
          "order_description_content": "按更新日期排列结果",
          "page_description_content": "从API返回哪个页码",
          "page_size_description_content": "每页从 API 返回多少结果",
          "required": "需要",
          "started_at_gteq_description_content": "大于或等于",
          "started_at_lteq_description_content": "小于或等于",
          "string": "字符串",
          "updated_at_gteq_description_content": "大于或等于",
          "updated_at_lteq_description_content": "小于或等于",
          "with_custom_fields_description_content": "允许显示自定义字段"
        },
        "performance_logs_params": {
          "csv_streaming_description_html": "CSV 格式 (<code>.csv</code>) 在单个响应中流式传输所有页面--只需调用一次端点即可接收完整的数据集。",
          "csv_streaming_title": "CSV 格式",
          "cursor_description": "上一次响应的分页标记 - 通过它来获取下一页面",
          "filters_heading": "可选过滤器",
          "limit_description": "每次请求返回的性能日志的最大数量",
          "machine_ids_description": "将结果过滤为特定的机器 ID（授权机器子集）",
          "pagination_step_1_html": "将<code>自</code> 设置为要检索性能日志的日期（必填，ISO 8601 格式，例如<code>2025-01-15T00:00:00Z</code>)",
          "pagination_step_2_html": "调用端点 - 每页最多可接收 2000 条记录（可通过<code>限制自定义</code> ，最多 2000 条）",
          "pagination_step_3_html": "使用回复中的<code>links.next</code> URL 获取下一页面",
          "pagination_step_4_html": "继续获取下一页，直到<code>links.next</code> 为空 - 您已获取所有记录",
          "pagination_title": "如何检索性能日志（JSON）",
          "parameters_heading": "参数",
          "range_filter_description": "必须同时使用 - 查找时间范围与查询范围重叠的记录",
          "since_description": "获取此日期后更新的性能日志",
          "with_custom_fields_description": "在响应中包含自定义字段值"
        },
        "schedule": "规划",
        "share_name": "分享名称",
        "simplified_losses_v2_params": {
          "csv_streaming_description_html": "CSV 格式 (<code>.csv</code>) 在单个响应中流式传输所有页面--只需调用一次端点即可接收完整的数据集。",
          "csv_streaming_title": "CSV 格式",
          "cursor_description": "上一次响应的分页标记 - 通过它来获取下一页面",
          "filters_heading": "可选过滤器",
          "limit_description": "每次请求返回的最大简化损失数",
          "machine_ids_description": "将结果过滤为特定的机器 ID（授权机器子集）",
          "pagination_step_1_html": "将<code>自</code> 设置为要检索简化损失的日期（必填，ISO 8601 格式，例如<code>2025-01-15T00:00:00Z</code>)",
          "pagination_step_2_html": "调用端点 - 每页最多可接收 2000 条记录（可通过<code>限制自定义</code> ，最多 2000 条）",
          "pagination_step_3_html": "使用回复中的<code>links.next</code> URL 获取下一页面",
          "pagination_step_4_html": "继续获取下一页，直到<code>links.next</code> 为空 - 您已获取所有记录",
          "pagination_title": "如何检索简化的损失（JSON）",
          "parameters_heading": "参数",
          "range_filter_description": "必须同时使用 - 查找时间范围与查询范围重叠的记录",
          "since_description": "获取此日期后更新的简化损失",
          "with_custom_fields_description": "在响应中包含自定义字段值"
        },
        "source": "数据来源",
        "storage_type": "存储类型",
        "time": "时间",
        "time_zone": "时区",
        "transform_plan": "转换配置",
        "type": "类型",
        "user": "用户"
      },
      "updated": "更新成功！"
    },
    "flow_histories": {
      "created": "注册成功！",
      "destroyed": "删除成功！",
      "index": {
        "actions": "行动",
        "created_at": "实施日期",
        "daterangepicker": {
          "apply_label": "确认",
          "april": "四月",
          "august": "八月",
          "cancel_label": "取消",
          "december": "十二月",
          "february": "二月",
          "fr": "周五",
          "january": "一月",
          "july": "七月",
          "june": "六月",
          "march": "三月",
          "may": "五月",
          "mo": "周一",
          "november": "十一月",
          "october": "十月",
          "sa": "周六",
          "september": "九月",
          "su": "周日",
          "th": "周四",
          "tu": "周二",
          "we": "周三"
        },
        "filter": "筛选器",
        "flow_configuration": "数据配置",
        "id": "id",
        "interval": "间隔",
        "no_results_founded": "没有找到所选时期的结果"
      },
      "many": "数据历史",
      "one": "数据历史",
      "show": {
        "Status": "状态",
        "actions": "行动",
        "flow_configuration": "配置",
        "id": "id",
        "operator": "操作员"
      },
      "updated": "更新成功！"
    },
    "friday": "星期五",
    "gate_monitoring": "闸门监控",
    "googledrive": "谷歌硬盘",
    "helpers": {
      "select": {
        "prompt": "请选择"
      },
      "submit": {
        "create": "新增%{model}",
        "submit": "储存%{model}",
        "update": "更新%{model}"
      }
    },
    "hi": "你好",
    "home": {
      "show": {
        "actions": "行动",
        "errors": "错误",
        "exports": "输出",
        "flow_configuration": "数据配置",
        "id": "id",
        "imports": "下载",
        "in_total": "总计",
        "last_exports": "最近一次输出",
        "last_imports": "最近一次下载",
        "last_week_errors": "最近7天的错误",
        "operator": "操作员",
        "status": "状态",
        "transformations": "转型"
      }
    },
    "hour": "小时",
    "hour_label_tootltip_text": "如果你选择了00:00的时间,提取将在所选的一天从早上开始进行。例如,在参考日&quot;星期一&quot;的00:00,提取将从星期一早上00:00开始。",
    "hour_label_tootltip_text_FID": "如果选择06:00，时间从前一天的06:00到第二天的06:00止。",
    "hourly": "每小时",
    "hours": "小时",
    "hutchinson_custom_one": "哈金森版本",
    "hutchinsoncustomeone": "哈金森版本",
    "hutchinsoncustomone": "哈钦森定制",
    "i18n": {
      "plural": {
        "keys": [
          "other"
        ]
      },
      "transliterate": {
        "rule": {
          "À": "A",
          "Â": "A",
          "Æ": "Ae",
          "Ç": "C",
          "È": "E",
          "É": "E",
          "Ê": "E",
          "Ë": "E",
          "Î": "I",
          "Ï": "I",
          "Ô": "O",
          "Ù": "U",
          "Û": "U",
          "Ü": "U",
          "à": "a",
          "â": "a",
          "æ": "ae",
          "ç": "c",
          "è": "e",
          "é": "e",
          "ê": "e",
          "ë": "e",
          "î": "i",
          "ï": "i",
          "ô": "o",
          "ù": "u",
          "û": "u",
          "ü": "u",
          "ÿ": "y",
          "Œ": "Oe",
          "œ": "oe",
          "Ÿ": "Y"
        }
      }
    },
    "import_export_profile": "出口概况",
    "in_progress": "正在进行中",
    "interval": {
      "a_week_ago": "上一周",
      "custom_interval": "自定义间隔",
      "last_12_hours": "最后12小时",
      "last_21_days": "最近 21 天",
      "last_24_hours": "最后24小时",
      "last_2_hours": "最后2小时",
      "last_30_days": "最后30天",
      "last_6_hours": "最后6小时",
      "last_7_days": "最后7天",
      "last_8_hours": "最后8小时",
      "last_day": "最后一天",
      "last_hour": "最后1小时",
      "last_month": "上一个月"
    },
    "json": "JSON",
    "logout": "退出",
    "machineproductcount": "产品计数",
    "merck_custom_one": "默克定制",
    "merckcustomone": "默克定制",
    "microsoftazure": "微软 Azure",
    "monday": "星期一",
    "monitoring": "监测",
    "month": "月",
    "monthly": "每月",
    "new_account_could_not_be_saved": "无法创建一个新账户",
    "next": "下列的",
    "no_transformation": "没有转换",
    "not_finished": "未完成",
    "nth_each_month": "每个月的",
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u %n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "CN¥"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "十亿",
            "million": "百万",
            "quadrillion": "千兆",
            "thousand": "千",
            "trillion": "兆",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": "字节",
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "nth": {},
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "operation_not_found": "没有找到所要求的操作!",
    "operations": {
      "one": "操作",
      "show": {
        "content": "内容",
        "created_at": "创建日期",
        "errors": "错误",
        "finished_at": "完成于",
        "flow": "增加",
        "id": "id",
        "informations": "信息",
        "initiator": "启动者",
        "logs": "日志历史",
        "name": "名称",
        "no_errors": "没有错误",
        "partial_coverage": {
          "summary": "L'export a livré cette fenêtre, mais la plateforme n'a pas pu la calculer pour les machines ci-dessous. Leurs données manquent dans le fichier, et leurs périodes ne sont pas vides.",
          "title": "Des machines manquent dans cet export"
        },
        "processed_files": "已处理的文件",
        "started_at": "开始于",
        "status": "状态",
        "undeliverable_export": {
          "covered_from": "Couverte à partir du",
          "machine": "Machine",
          "platform_error": "Signalé par la plateforme",
          "range": "du %{started_at} au %{ended_at}",
          "reason": "Raison",
          "reasons": {
            "no_loss_configuration": "Aucune configuration des pertes n'est affectée à cette machine. Affectez-lui une configuration pour que la plateforme puisse calculer cette fenêtre.",
            "no_pace_cause_configuration": "Aucune configuration des causes de cadence n'est affectée à cette machine. Affectez-lui une configuration pour que la plateforme puisse calculer cette fenêtre.",
            "no_shift_configuration": "Aucune configuration des équipes n'est affectée à cette machine. Affectez-lui une configuration pour que la plateforme puisse calculer cette fenêtre.",
            "no_shift_schedule_in_range": "La configuration des équipes de cette machine ne place aucune équipe dans cette fenêtre. Étendez-la sur cette fenêtre, ou réglez le flux sur une fenêtre qu'elle couvre.",
            "range_starts_before_shift_configuration": "La fenêtre commence avant la date de début de la configuration des équipes de cette machine. Avancez cette date de début, ou réglez le flux sur une fenêtre qui commence à cette date ou plus tard.",
            "shift_configuration_has_unassigned_duration": "La configuration des équipes de cette machine laisse des périodes sans équipe, ses durées ne couvrent donc pas tout son cycle. Complétez les périodes manquantes.",
            "shift_configuration_not_anchored": "La configuration des équipes de cette machine n'a pas de date de début. Renseignez une date de début antérieure ou égale au début de cette fenêtre."
          },
          "summary": "La plateforme n'a pas pu calculer cette fenêtre, l'export n'a donc rien livré pour cette période. Cette période n'est pas vide.",
          "title": "Aucune donnée livrée pour cette fenêtre",
          "uncovered_machines": "Machines non couvertes",
          "utc_timestamp": "%{timestamp} UTC",
          "window": "Fenêtre"
        }
      }
    },
    "pace_defta_custom_one": "PACETRAK Defta 定制",
    "pacedeftacustomone": "PACETRAK Defta 定制",
    "pending": "待定",
    "per_shift": "每班",
    "perf_cycletime_product": "Perf Cycletime 产品",
    "perf_startstop_product": "Perf Startstop 产品",
    "perfcycletimeproduct": "Perf Cycletime 产品",
    "performance_log": "性能日志 (v2)",
    "performance_log_feed": "Journaux de performance (flux)",
    "performancelogfeed": "Journaux de performance (flux)",
    "perfstartstopproduct": "Perf Startstop 产品",
    "please_choose_a_custom_interval": "选择间隔",
    "please_choose_an_option": "选择一个选项",
    "please_choose_the_desired_export_destination": "请选择一个目的地",
    "please_choose_the_desired_source": "请选择一个来源",
    "please_choose_the_desired_transform_plan": "请选择一个转型计划",
    "please_fill_in_the_form_below": "请填写以下表格",
    "please_review_the_errors_below": "请纠正以下错误",
    "powered_by_teeptrak": "由 TEEPTRAK 提供动力",
    "privacy_policy": "数据隐私（GDPR）",
    "product_counts_for_a_machine": "产品计数",
    "product_name_label_tootltip_text": "产品选择是可选的",
    "production_order_line": "生产订单",
    "productionorderline": "生产订单",
    "qual_hutchinson_custom_one": "Qualtrak Hutchinson 定制",
    "qualhutchinsoncustomone": "Qualtrak Hutchinson 定制",
    "quartly": "每15分钟一次",
    "raw_data": "原始数据",
    "rawdata": "原始数据",
    "required": "必要",
    "saturday": "星期六",
    "save_form": "保存",
    "savencia_custom_one": "Savencia 定制",
    "savenciacustomone": "Savencia 定制",
    "server_alibaba_shanghai": "服务器位于上海",
    "server_alibaba_shenzhen": "服务器位于深圳",
    "server_ovh": "位于欧洲的服务器",
    "shiftly": "按轮班",
    "simple_form": {
      "error_notification": {
        "default_message": "Veuillez examiner les problèmes ci-dessous:"
      },
      "labels": {
        "configuration": {
          "cron": "计划",
          "day": "日",
          "day_number": "日",
          "days": "日期",
          "name": "文件名",
          "time": "时间"
        },
        "import_source": {
          "interval": "间隔",
          "type": "类型"
        }
      },
      "non": "Non",
      "oui": "Oui",
      "required": {
        "mark": "*",
        "text": "Nécessaire"
      }
    },
    "simplified_loss_feed": "Pertes simplifiées (flux)",
    "simplified_loss_v2": "简化损失 (v2)",
    "simplified_losses": {
      "maximum_requests": "你在一个小时内提出了太多的要求。你必须等待%{maximum_requests}小时才能提出新的请求。",
      "time_before_next_request": "太多的同时请求。请等待%{time_before_next_request}秒。"
    },
    "simplified_losses_duration_for_a_machine": "简化的损失数据",
    "simplifiedloss": "简化的损失数据",
    "simplifiedlossfeed": "Pertes simplifiées (flux)",
    "simplifiedlossv2": "简化损失 (v2)",
    "solina_custom_one": "索丽娜版",
    "solina_custom_two": "索丽娜定制 (2)",
    "solinacustomeone": "索丽娜版",
    "solinacustometwo": "索丽娜定制 (2)",
    "solinacustomone": "SOLINA 定制",
    "solinacustomtwo": "SOLINA custom (2)",
    "source": "来源",
    "sunday": "星期天",
    "support": {
      "array": {
        "last_word_connector": "、",
        "two_words_connector": "和",
        "words_connector": "、"
      }
    },
    "thursday": "星期四",
    "time": {
      "am": "上午",
      "formats": {
        "default": "%Y年%m月%d日 %A %H:%M:%S %Z",
        "long": "%Y年%m月%d日 %H:%M",
        "short": "%m月%d日 %H:%M"
      },
      "pm": "下午"
    },
    "total_of": "总数",
    "transform_plan": "转型计划",
    "true": "真",
    "tuesday": "星期二",
    "type": "类型",
    "views": {
      "pagination": {
        "first": "« 第一页",
        "last": "最后一页 »",
        "next": "下一页 ›",
        "previous": "‹ 上一页",
        "truncate": "..."
      }
    },
    "wednesday": "星周三",
    "week": "周",
    "weekly": "每周",
    "welcome_to_teeptrak_gate": "欢迎访问Teeptrak Gate"
  }
});

export default i18n;
